import type { ContentItem } from '../contentLibrary'

export const MING_ARTICLES: ContentItem[] = [
  {
    id: 'poem-ming-luohuatu',
    category: 'poem',
    dynasty: 'ming',
    title: '落花圖并詩 卷',
    source: '沈周',
    description: '明代沈周晚年抒情名作，台北故宮博物院典藏《落花圖并詩卷》所錄落花詩十首全文。',
    content: '富逞穠華滿樹春，香飄瓣落樹還貧。紅芳既蛻仙成道，綠葉初陰子養仁。偶補燕巢泥薦寵，別修蜂蜜水資神。年年為爾添惆悵，獨是娥眉未嫁人。\n\n飄飄蕩蕩復悠悠，樹底追尋到樹頭。趙武泥塗知辱雨，秦宮脂粉惜隨流。癡情戀酒粘紅袖，急意穿簾泊玉鈎。欲拾殘芳搗為藥，傷春難療箇中愁。\n\n玉勒銀罌已倦遊，東飛西落使人愁。急攙春去先辭樹，嬾被風扶強上樓。魚沫劬恩殘粉在，蛛絲牽愛小紅留。色香久在沉迷界，懺悔誰能倩比丘。\n\n是誰揉碎錦雲堆，著地難扶氣力頹。懊惱夜生聽雨枕，浮沈朝入送春杯。梢傍小剩鶯還掠，風背差遲鴃又催。瞥眼興亡供一笑，竟因何落竟何開。\n\n夕陽無那小橋西，春事闌珊意欲迷。錦里門前溪好浣，黃陵廟裡鳥還啼。焚追螺甲教香史，煎帶牛酥矚膳㜎。萬寶千鈿真可惜，歸來直欲滿筐攜。\n\n一園桃李只須臾，白白朱朱徹樹無。亭怪草玄加舊白，窗嫌點易亂新朱。無方漂泊關遊子，如此衰殘類老夫。來歲重開還自好，小篇聊復記榮枯。\n\n芳菲死日是生時，李妹桃娘盡欲兒。人散酒闌春亦去，紅消綠長物無私。青山可惜文章喪，黃土何堪錦繡施。空記少年簪舞處，飄零今日鬢如絲。\n\n供送春愁上客眉，亂紛紛地竚多時。儗招綠妾難成些，戲比紅兒煞要詩。臨水東風撩短髩，惹空晴日共遊絲。還隨蛺蝶追尋去，墻角公然隱半枝。\n\n昨日繁華煥眼新，今朝瞥眼又成塵。深關羊戶無來客，漫藉周亭有醉人。露涕煙洟傷故物，蝸涎蟻迹吊殘春。門墻蹊徑俱寥落，丞相知時卻不嗔。\n\n百五光陰瞬息中，夜來無樹不驚風。踏歌女子思楊白，進酒才人賦雨紅。金水送香波共渺，玉堦看影月俱空。當時深院還重鎖，今出墻頭西復東。',
  },
  {
    id: 'poem-ming-shihui',
    category: 'poem',
    dynasty: 'ming',
    title: '石灰吟',
    source: '于謙',
    description: '于謙以石灰自喻，表現堅貞不屈的品格。',
    content: '千錘萬鑿出深山，烈火焚燒若等閑。粉骨碎身渾不怕，要留清白在人間。',
  },

  {
    id: 'poem-ming-taohuaan',
    category: 'poem',
    dynasty: 'ming',
    title: '桃花庵歌',
    source: '唐寅',
    description: '唐寅自況之作，灑脫不羈，看破紅塵。',
    content: '桃花塢裡桃花庵，桃花庵下桃花仙。桃花仙人種桃樹，又摘桃花換酒錢。酒醒只在花前坐，酒醉還來花下眠。半醒半醉日復日，花落花開年復年。但願老死花酒間，不願鞠躬車馬前。車塵馬足富者趣，酒盞花枝貧者緣。若將富貴比貧者，一在平地一在天。若將貧賤比車馬，他得驅馳我得閒。別人笑我忒瘋癲，我笑他人看不穿。不見五陵豪傑墓，無花無酒鋤作田。',
  },

  {
    id: 'poem-ming-huaji',
    category: 'poem',
    dynasty: 'ming',
    title: '畫雞',
    source: '唐寅',
    description: '唐寅題畫詩，寫雄雞之威風與報曉之責。',
    content: '頭上紅冠不用戴，滿身雪白走將來。平生不敢輕言語，一叫千門萬戶開。',
  },

  {
    id: 'poem-ming-mudanting',
    category: 'poem',
    dynasty: 'ming',
    title: '牡丹亭·遊園驚夢（全文）',
    source: '湯顯祖',
    description: '杜麗娘遊園感春，驚覺韶華易逝，千古絕唱。',
    content: '【步步嬌】裊晴絲吹來閒庭院，搖漾春如線。停半晌、整花鈿。沒揣菱花，偷人半面，迤逗的彩雲偏。步香閨怎便把全身現！【醉扶歸】你道翠生生出落的裙衫兒茜，豔晶晶花簪八寶填，可知我常一生兒愛好是天然。恰三春好處無人見。不隄防沉魚落雁鳥驚諠，則怕的羞花閉月花愁顫。【皂羅袍】原來奼紫嫣紅開遍，似這般都付與斷井頹垣。良辰美景奈何天，賞心樂事誰家院？朝飛暮卷，雲霞翠軒；雨絲風片，煙波畫船——錦屏人忒看的這韶光賤！【好姐姐】遍青山啼紅了杜鵑，荼蘼外煙絲醉軟。春香呵，牡丹雖好，他春歸怎占的先！閒凝眄，生生燕語明如翦，嚦嚦鶯歌溜的圓。【隔尾】觀之不足由他繾，便賞遍了十二亭臺是枉然。到不如興盡回家閒過遣。',
  },

  {
    id: 'poem-ming-linjiangxian',
    category: 'poem',
    dynasty: 'ming',
    title: '臨江仙·滾滾長江東逝水',
    source: '楊慎',
    description: '楊慎懷古詞，以長江東去寓歷史興亡，曠達蒼涼。',
    content: '滾滾長江東逝水，浪花淘盡英雄。是非成敗轉頭空。青山依舊在，幾度夕陽紅。白髮漁樵江渚上，慣看秋月春風。一壺濁酒喜相逢。古今多少事，都付笑談中。',
  },

  {
    id: 'poem-ming-fanhai',
    category: 'poem',
    dynasty: 'ming',
    title: '泛海',
    source: '王守仁',
    description: '王陽明泛海詩，氣魄宏偉，表現不畏艱險的心學精神。',
    content: '險夷原不滯胸中，何異浮雲過太空。夜靜海濤三萬里，月明飛錫下天風。',
  },

  {
    id: 'classic-ming-yonglaba',
    category: 'poem',
    dynasty: 'ming',
    title: '朝天子·詠喇叭',
    source: '王磐',
    description: '王磐借喇叭諷刺宦官作威作福，幽默辛辣。',
    content: '喇叭，嗩吶，曲兒小腔兒大。官船來往亂如麻，全仗你抬聲價。軍聽了軍愁，民聽了民怕。哪裡去辨甚麼真共假？眼見的吹翻了這家，吹傷了那家，只吹的水盡鵝飛罷。',
  },

  {
    id: 'classic-ming-xiangjixuan',
    category: 'classic',
    dynasty: 'ming',
    title: '項脊軒志（全文）',
    source: '歸有光',
    description: '歸有光借一軒之記，悼念亡母亡妻，平淡中見真情。',
    content: '項脊軒，舊南閣子也。室僅方丈，可容一人居。百年老屋，塵泥滲漉，雨澤下注；每移案，顧視無可置者。又北向，不能得日，日過午已昏。余稍為修葺，使不上漏。前辟四窗，垣牆周庭，以當南日，日影反照，室始洞然。又雜植蘭桂竹木於庭，舊時欄楯，亦遂增勝。借書滿架，偃仰嘯歌，冥然兀坐，萬籟有聲；而庭堦寂寂，小鳥時來啄食，人至不去。三五之夜，明月半牆，桂影斑駁，風移影動，珊珊可愛。然余居於此，多可喜，亦多可悲。先是，庭中通南北為一。迨諸父異爨，內外多置小門，牆往往而是。東犬西吠，客逾庖而宴，雞棲於廳。庭中始為籬，已為牆，凡再變矣。家有老嫗，嘗居於此。嫗，先大母婢也，乳二世，先妣撫之甚厚。室西連於中閨，先妣嘗一至。嫗每謂余曰：「某所，而母立於茲。」嫗又曰：「汝姊在吾懷，呱呱而泣；娘以指扣門扉曰：『兒寒乎？欲食乎？』吾從板外相為應答。」語未畢，余泣，嫗亦泣。余自束髮讀書軒中，一日，大母過余曰：「吾兒，久不見若影，何竟日默默在此，大類女郎也？」比去，以手闔門，自語曰：「吾家讀書久不效，兒之成，則可待乎！」頃之，持一象笏至，曰：「此吾祖太常公宣德間執此以朝，他日汝當用之。」瞻顧遺跡，如在昨日，令人長號不自禁。軒東故嘗為廚，人往，從軒前過。余扃牖而居，久之，能以足音辨人。軒凡四遭火，得不焚，殆有神護者。項脊生曰：「蜀清守丹穴，利甲天下，其後秦皇帝築女懷清台。劉玄德與曹操爭天下，諸葛孔明起隴中。方二人之昧昧於一隅也，世何足以知之？余區區處敗屋中，方揚眉瞬目，謂有奇景；人知之者，其謂與埳井之蛙何異？」余既為此志，後五年，吾妻來歸，時至軒中，從余問古事，或憑几學書。吾妻歸寧，述諸小妹語曰：「聞姊家有閣子，且何謂閣子也？」其後六年，吾妻死，室壞不修。其後二年，余久臥病無聊，乃使人複葺南閣子，其制稍異於前。然自後余多在外，不常居。庭有枇杷樹，吾妻死之年所手植也，今已亭亭如蓋矣。',
  },

  {
    id: 'classic-ming-huxinting',
    category: 'classic',
    dynasty: 'ming',
    title: '湖心亭看雪',
    source: '張岱',
    description: '張岱小品文名篇，寫雪夜獨遊西湖的幽絕之境。',
    content: '崇禎五年十二月，余住西湖。大雪三日，湖中人鳥聲俱絕。是日更定矣，余挐一小舟，擁毳衣爐火，獨往湖心亭看雪。霧凇沆碱，天與雲與山與水，上下一白，湖上影子，惟長堤一痕、湖心亭一點、與余舟一芥、舟中人兩三粒而已。到亭上，有兩人鋪氈對坐，一童子燒酒爐正沸。見余大喜曰：「湖中焉得更有此人！」拉余同飲。余強飲三大白而別。問其姓氏，是金陵人，客此。及下船，舟子喃喃曰：「莫說相公癡，更有癡似相公者。」',
  },

  {
    id: 'classic-ming-biejian',
    category: 'poem',
    dynasty: 'ming',
    title: '別雲間',
    source: '夏完淳',
    description: '夏完淳就義前所作，悲壯慷慨，英氣逼人。',
    content: '三年羈旅客，今日又南冠。無限山河淚，誰言天地寬。已知泉路近，欲別故鄉難。毅魄歸來日，靈旗空際看。',
  },

  {
    id: 'classic-ming-tongxinshuo',
    category: 'classic',
    dynasty: 'ming',
    title: '童心說（全文）',
    source: '李贄',
    description: '李贄主張保持赤子之心，反對虛偽禮教。',
    content: '龍洞山農敘《西廂》，末語云：「知者勿謂我尚有童心可也。」夫童心者，真心也。若以童心為不可，是以真心為不可也。夫童心者，絕假純真，最初一念之本心也。若失卻童心，便失卻真心；失卻真心，便失卻真人。人而非真，全不復有初矣。童子者，人之初也；童心者，心之初也。夫心之初，曷可失也？然童心胡然而遽失也？蓋方其始也，有聞見從耳目而入，而以為主於其內，而童心失。其長也，有道理從聞見而入，而以為主於其內，而童心失。其久也，道理聞見，日以益多，則所知所覺，日以益廣，於是焉又知美名之可好也，而務欲以揚之，而童心失。知不美之名之可醜也，而務欲以掩之，而童心失。夫道理聞見，皆自多讀書識義理而來也。古之聖人，曷嘗不讀書哉！然縱不讀書，童心固自在也；縱多讀書，亦以護此童心而使之勿失焉耳，非若學者反以多讀書識理而反障之也。夫學者既以多讀書識義理障其童心矣，聖人又何用多著書立言，以障學人為耶？童心既障，於是發而為言語，則言語不由衷；見而為政事，則政事無根柢；著而為文辭，則文辭不能達；非內含以章美也，非篤實生輝光也，欲求一句有德之言，卒不可得，所以者何？以童心既障，而以從外入者聞見道理為之心也。夫既以聞見道理為心矣，則所言者，皆聞見道理之言，非童心自出之言也，言雖工，於我何與！豈非以假人言假言，而事假事、文假文乎！蓋其人既假，則無所不假矣。由是而以假言與假人言，則假人喜；以假事與假人道，則假人喜；以假文與假人談，則假人喜；無所不假則無所不喜，滿場是假，矮場阿辯也。雖有天下之至文，其湮滅於假人而不盡見於後世者，又豈少哉！何也？天下之至文，未有不出於童心焉者也。苟童心常存，則道理不行，聞見不立，無時不文，無人不文，無一樣創制體格而非文者。詩何必古選，文何必先秦，降而為六朝，變而為近體，又變而為傳奇，變而為院本，為雜劇，為《西廂曲》，為《水滸傳》，為今之舉子業，大賢言聖人之道，皆古今至文，不可得而時勢先後論也。故吾因是有感於童心者之自文也，更說什麼六經，更說什麼《語》、《夢》乎！夫六經、《語》、《孟》，非其史官過為褒崇之詞，則其臣子極為贊美之語，又不然則其迂腐門徒、懵懂弟子，記憶師說，有頭無尾，得後遺前，隨其所見，筆之於書，後學不察，便為出自聖人之口也，決定目之為經矣，孰知其大半非聖人之言乎！縱出自聖人，要亦有為而發，不過因病發藥，隨時處方，以救此一等懵懂弟子、迂腐門徒雲耳。藥醫假病，方難定執，是豈可遽以為萬世之論乎！然則六經、《語》、《孟》，乃道學之口實，假人之淵薮也，斷斷乎其不可以語於童心之言明矣。',
  },

  {
    id: 'classic-ming-chibi',
    category: 'classic',
    dynasty: 'ming',
    title: '滿井遊記（全文）',
    source: '袁宏道',
    description: '袁宏道寫初春滿井之遊，筆調清新明快。',
    content: '燕地寒，花朝節後，餘寒猶厲。凍風時作，作則飛沙走礫。局促一室之內，欲出不得。每冒風馳行，未百步輒返。廿二日，天稍和，偕數友出東直，至滿井。高柳夾堤，土膏微潤，一望空闊，若脫籠之鵠。於時冰皮始解，波色乍明，鱗浪層層，清澈見底，晶晶然如鏡之新開而冷光之乍出於匣也。山巒為晴雪所洗，娟然如拭，鮮妍明媚，如倩女之靧面而髻鬟之始掠也。柳條將舒未舒，柔梢披風，麥田淺鬣寸許。遊人雖未盛，泉而茗者，罍而歌者，紅裝而蹇者，亦時時有。風力雖尚勁，然徒步則汗出浹背。凡曝沙之鳥，呷浪之鱗，悠然自得，毛羽鱗鬣之間，皆有喜氣。始知郊田之外，未始無春，而城居者未之知也。夫不能以遊墮事，而瀟然於山石草木之間者，惟此官也。而此地適與余近，余之遊將自此始，惡能無紀？己亥之二月也。',
  },

  {
    id: 'classic-songdongyang',
    category: 'classic',
    dynasty: 'ming',
    title: '送東陽馬生序',
    source: '宋濂',
    description: '宋濂以自身苦學經歷勉勵後輩，勤學有成。',
    content: '余幼時即嗜學。家貧，無從致書以觀，每假借於藏書之家，手自筆錄，計日以還。天大寒，硯冰堅，手指不可屈伸，弗之怠。錄畢，走送之，不敢稍逾約。以是人多以書假余，余因得遍觀群書。既加冠，益慕聖賢之道，又患無碩師、名人與遊，嘗趨百里外，從鄉之先達執經叩問。先達德隆望尊，門人弟子填其室，未嘗稍降辭色。余立侍左右，援疑質理，俯身傾耳以請；或遇其叱咄，色愈恭，禮愈至，不敢出一言以復；俟其欣悅，則又請焉。故余雖愚，卒獲有所聞。當余之從師也，負篋曳屣，行深山巨谷中，深冬烈風，大雪深數尺，足膚皲裂而不知。至舍，四支僵勁不能動，媵御設醴給溫，以衾擁覆，久而乃和。寓逆旅，主人日再食，無鮮肥滋味之享。同舍生皆被綺繡，戴朱纓寶飾之帽，腰白玉之環，左佩刀，右備容臭，燁然若神人；余則縕袍敝衣處其間，略無慕豔意。以中有足樂者，不知口體之奉不若人也。蓋余之勤且艱若此。今雖耄老，未有所成，猶幸得與專心之列，而又獲有所聞，況才之秀者乎？',
  },

  {
    id: 'classic-maiganzheyan',
    category: 'classic',
    dynasty: 'ming',
    title: '賣柑者言',
    source: '劉基',
    description: '劉基借賣柑者之口，譏諷朝中官員外強中乾。',
    content: '杭有賣果者，善藏柑，涉寒暑不潰。出之燁然，玉質而金色。置於市，賈十倍，人爭售之。予買一個，剖之，如有煙撲口鼻，視其中，乾癟如敗絮。予怪而問之曰：「子所賣柑，將以實籩豆，奉祭祀，供賓客乎？將炫外以惑愚瞽乎？甚矣哉，子之檮也！」賣柑者笑曰：「吾業是有年矣，吾賴是以食吾軀。吾售之，人取之，未嘗有言，而獨子滿足邪？世之為欺者不寡矣，而獨我也乎？吾子未之思也。今夫佩虎符、坐皋比者，洸洸乎干城之具也，果能授孫、吳之略乎？戴高冠、侍長紳者，昂昂乎廟堂之器也，果能建伊、皋之業乎？盜起而不知御，民困而不知救，吏奸而不知禁，法斁而不知理，坐糜廩粟而不知恥。觀其坐高堂，騎大馬，醉醇醲而飫肥鮮者，孰不巍巍乎可畏，赫赫乎可象也？又何往而不金玉其外，敗絮其中也哉？今子是之不察，而以察吾柑！」予默然無以應。退而思其言，類東方生滑稽之流。豈其憤世疾邪者而託於柑以諷耶？',
  },

  {
    id: 'classic-ming-yuanhongdao',
    category: 'classic',
    dynasty: 'ming',
    title: '晚遊六橋待月記',
    source: '袁宏道',
    description: '性靈派代表袁宏道描寫西湖月夜美景的散文精品。',
    content: '西湖最盛，為春為月。一日之盛，為朝煙，為夕嵐。今歲春雪甚盛，梅花為寒所勒，與杏桃相次開發，尤為大快。袁子曰：杭人遊湖，止午、未、申三時；其實湖光染翠之工，山嵐設色之妙，皆在朝日始出，夕舂未下，始極其濃媚。月景尤不可言，花態柳情，山容水意，別是一種趣味。此樂留與山僧遊客受用，安可為俗士道哉！',
  },

  {
    id: 'poem-ming-qijiguang',
    category: 'poem',
    dynasty: 'ming',
    title: '馬上作',
    source: '戚繼光',
    description: '抗倭名將戚繼光奔波沙場的豪邁報國詩作。',
    content: '南北驅馳報國情，江花邊月笑平生。一年三百六十日，多是橫戈馬上行。',
  },

  {
    id: 'poem-ming-gaoqi',
    category: 'poem',
    dynasty: 'ming',
    title: '梅花·其一',
    source: '高啟',
    description: '明初詩人高啟詠梅名作，超凡脫俗，格調孤高。',
    content: '瓊姿只合在瑤台，誰向江南處處栽？雪滿山中高士臥，月明林下美人來。寒依疏影蕭蕭竹，春掩殘香漠漠苔。自去何須尋載酒，悠然獨賞歲寒開。',
  },

  {
    id: 'poem-ming-yuanmuzhai',
    category: 'poem',
    dynasty: 'ming',
    title: '袁幕宅晚眺',
    source: '徐渭',
    description: '徐渭寫暮色中的田園風光。',
    content: '山雨乍收雲腳低，江天如墨月初移。一雙白鷺下林外，飛過前村又幾枝。',
  },

  {
    id: 'calligraphy-tangyin-luohua',
    category: 'calligraphy',
    dynasty: 'ming',
    title: '唐寅·落花詩三十首 (全文)',
    source: '唐寅',
    description: '唐伯虎代表行書字帖《落花詩三十首》全文。感懷春光易逝與身世沉浮，筆法圓潤流暢，極具江南才子風流儒雅之氣。',
    content: '剎那斷送十分春，富貴園林一洗貧。借問牧童應沒酒，試嘗梅子又生仁。若為軟舞欺花旦，難保餘香笑樹神。料得青鞋攜手伴，日高都做晏眠人。\n\n夕陽黯黯笛悠悠，一霎春風又轉頭。控訴欲呼天北極，胭脂都付水東流。傾盆怪雨泥三尺，繞樹佳人繡半鈎。顏色自來皆夢幻，一番添得鏡中愁。\n\n春風百五盡須臾，花事飄零剩有無。新酒快傾杯上綠，衰顏已改鏡中朱。絕纓不見偷香椽，墮溷翻成逐臭夫。身漸衰頹類如此，樹和淚眼合同枯。\n\n芳菲死日是生時，李妹桃娘盡欲兒。人散酒闌春亦去，紅消綠長物無私。青山可惜文章喪，黃土何堪錦繡施。空記少年簪舞處，飄零今日鬢如絲。\n\n供送春愁上客眉，亂紛紛地竚多時。擬招綠妾難成些，戲比紅兒煞要詩。臨水東風撩短鬢，惹空晴日共遊絲。還隨蛺蝶追尋去，牆角公然隱半枝。\n\n昨日繁華煥眼新，今朝瞥眼又成塵。深關羊戶無來客，漫藉周亭有醉人。露涕煙洟傷故物，蝸涎蟻迹吊殘春。門牆蹊徑俱寥落，丞相知時卻不嗔。\n\n百五光陰瞬息中，夜來無樹不驚风。踏歌女子思楊白，進酒才人賦雨紅。金水送香波共渺，玉階看影月俱空。當時深院還重鎖，今出牆頭西復東。\n\n桃花淨盡杏花開，萬態雙扉傍水開。昨日流鶯還舊處，今朝蝴蝶又新來。春光有限如飛電，物色無情怨落梅。可惜風流張敞筆，寫得春色上妝臺。\n\n剎那芳草又迎春，物色牽人心自新。野水參差落桃李，東風吹折御街塵。幾家茅屋沾微雨，十里寒溪咽暮雲。為報韶光休草草，明年更見綠成群。\n\n香魂零落雨淒淒，杏小桑陰漸漸齊。枝上殘花堆點絳，樹頭新葉放青荑。舊巢燕子尋舊主，小徑蜂兒覓小溪。醉臥不知春去盡，滿空飛絮過橋西。\n\n暮春天氣雨迷茫，小院深沈鎖綠篁。滿地殘紅留不住，一簾飛絮自空忙。風吹花落添愁緒，月照影孤傷斷腸。獨自憑欄無奈何，夕陽西下水悠悠。\n\n春深無處不傷情，飛絮落花滿路明。舊日繁華成夢幻，今朝憔悴感漂零。風揉雨打紅芳盡，綠葉陰濃夏木成。留得殘香無處覓，獨留愁思寄聲詩。\n\n花開花落總無情，韶華轉眼暗中更。春風不管人憔悴，吹盡殘紅滿地輕。客裏逢春愁更甚，酒邊花落夢初驚。憑高遠眺江天闊，萬里雲山帶晚晴。\n\n一陣東風雨後晴，落花滿地送春行。綠陰漸密黃鶯啼，紅芳已盡彩蝶飛。感時傷怨情無限，懷古思今悲不勝。寄語東皇留稍許，莫教容易盡芳菲。\n\n紅褪殘香春意空，東風無力掃花紅。階前積雪非真雪，樹頭飛花似夢中。遊子傷春心欲碎，佳人感物淚雙垂。憑欄莫問歸何處，一片孤雲落日西。\n\n春归無跡意迷茫，花落人亡兩渺茫。昔日園林誇豔麗，如今池館冷淒涼。風吹殘粉飄香徑，月照孤影上步廊。無限傷春無限恨，盡將愁思賦文章。\n\n花落深村小徑幽，春光逝去令人愁。風催紅雨粘泥濕，日照綠陰覆樹稠。舊恨新愁情不盡，昔歡今怨事難留。憑高獨吟傷往事，一片斜陽滿水樓。\n\n春盡花殘意消沉，斜陽影裏獨低吟。飛紅點點傷春色，飄絮茫茫感客心。昔日歡娛成逝水，今朝寂寞對孤燈。憑欄不盡興亡感，一任東風吹短襟。\n\n風吹花落滿庭階，惆悵春光不可回。舊日紅芳隨水逝，今朝綠陰帶煙開。客中感懷情難盡，酒後高歌愁未解。寄語飛花休匆速，留將微香伴幽人。\n\n落花飛絮滿天涯，春去無痕感逝華。昔日繁華皆成空，如今憔悴獨自嗟。風打雨揉紅粉盡，綠葉陰濃夏日長。憑欄望盡天涯路，一片斜陽帶晚霞。\n\n春去花殘意綿綿，斜陽影裏聽啼鵑。落紅滿地無人掃，飛絮連天帶雨飄。舊事如夢情難忘，韶光似水歲月流。憑高獨目傷懷久，一曲清歌寄遠天。\n\n風吹落花飄滿地，感傷春去意難平。昔日紅芳誇豔美，今朝殘香落泥塗。遊子傷懷淚霑襟，佳人倚欄獨自吟。憑高遠望思無盡，一片斜陽落水濱。\n\n春深花落感年華，飛紅點點落人家。東风無情吹亂打，細雨有意潤新芽。舊歡如夢情難覓，新愁似織意無涯。憑欄高歌抒胸臆，一片斜陽帶晚霞。\n\n落花飄零隨水流，春去無痕令人愁。昔日繁華成陳跡，今朝憔悴獨自憂。風吹雨打紅芳盡，綠陰夏木覆林丘。憑高吟詠傷往事，一任斜陽下小樓。\n\n春光漸老花漸殘，飛紅飄絮滿山川。舊日園林成空夢，今朝池館冷清煙。風打雨揉香粉盡，綠葉陰濃夏木繁。憑欄高歌情無限，一片斜陽帶暮煙。\n\n落花飛絮動愁腸，春去無痕意感傷。昔日紅芳誇美麗，如今殘香落泥塗。風吹雨打情難盡，月照影孤事難忘。憑高吟詠抒懷抱，一片斜陽下西牆。\n\n春深花落令人嗟，飛紅點點落苔階。東風無力留春住，細雨有心潤物華。舊歡已去情難再，新愁又生意未涯。憑欄高歌寄遠思，一片斜陽帶晚霞。\n\n落花飄零隨風飛，春去無痕意難依。昔日繁華成空影，如今憔悴獨自哀。風吹雨打紅芳盡，綠陰夏木覆柴扉。憑欄遠眺傷懷久，一片斜陽下遠山。\n\n春光逝去花漸殘，飛紅飄絮滿人間。舊日園林誇美麗，今朝池館冷風寒。風打雨揉香粉盡，綠葉陰濃夏日長。憑欄高歌抒胸臆，一片斜陽下西山。\n\n落花飛絮滿庭空，春去無痕意無窮。昔日繁華成舊夢，今朝憔悴獨留痛。風吹雨打紅芳盡，綠陰夏木覆東風。憑欄吟詠傷往事，一片斜陽落照中。',
  },

  {
    id: 'classic-ming-gongzhiqiao',
    category: 'poem',
    dynasty: 'ming',
    title: '郁離子·工之僑獻琴',
    source: '劉基',
    description: '「台灣高中」學段寓言名篇，劉基諷刺元末重虛名、輕實質的荒謬社會風氣。',
    content: '工之僑得良桐焉，斫而為琴，弦而鼓之，金聲而玉應。自以為天下之美也，獻之太常。使國工視之，曰：「弗古。」還之。工之僑以歸，謀諸漆工，作斷紋焉；又謀諸篆工，作古籕焉；匣而埋諸土。期年出之，抱以適市。貴人過而購之，易之以百金。獻之太常.國工皆歷下之，曰：「希世之珍也。」工之僑聞之，嘆曰：「悲哉世也！豈獨一琴哉？莫不然矣！而不早圖之，以與翳翳且死。」遂去，入神仙之山，不知所終。',
  },
  {
    id: 'classic-ming-xuwenchangchuan',
    category: 'classic',
    dynasty: 'ming',
    title: '徐文長傳',
    source: '袁宏道',
    description: '《古文觀止》收錄之經典名篇，作者為袁宏道。',
    content: '餘少時過裏肆中，見北雜劇有《四聲猿》，意氣豪達，與近時書生所演傳奇絕異，題曰“天池生”，疑爲元人作。後適越，見人家單幅上有署“田水月”者，強心鐵骨，與夫一種磊塊不平之氣，字畫之中，宛宛可見。意甚駭之，而不知田水月爲何人。\n一夕，坐陶編修樓，隨意抽架上書，得《闕編》詩一帙。惡楮毛書，煙煤敗黑，微有字形。稍就燈間讀之，讀未數首，不覺驚躍，忽呼石簣：“《闕編》何人作者？今耶？古耶？”石簣曰：“此餘鄉先輩徐天池先生書也。先生名渭，字文長，嘉、隆間人，前五六年方卒。今卷軸題額上有田水月者，即其人也。”餘始悟前後所疑，皆即文長一人。又當詩道荒穢之時，獲此奇祕，如魘得醒。兩人躍起，燈影下，讀復叫，叫復讀，僮僕睡者皆驚起。餘自是或向人，或作書，皆首稱文長先生。有來看餘者，即出詩與之讀。一時名公巨匠，浸浸知嚮慕雲。\n文長爲山陰秀才，大試輒不利，豪蕩不羈。總督胡梅林公知之，聘爲幕客。文長與胡公約：“若欲客某者，當具賓禮，非時輒得出入。”胡公皆許之。文長乃葛衣烏巾，長揖就坐，縱談天下事，旁若無人。胡公大喜。是時公督數邊兵，威振東南，介冑之士，膝語蛇行，不敢舉頭；而文長以部下一諸生傲之，信心而行，恣臆談謔，了無忌憚。會得白鹿，屬文長代作表。表上，永陵喜甚。公以是益重之，一切疏記，皆出其手。\n文長自負才略，好奇計，談兵多中。凡公所以餌汪、徐諸虜者，皆密相議然後行。嘗飲一酒樓，有數健兒亦飲其下，不肯留錢。文長密以數字馳公，公立命縛健兒至麾下，皆斬之，一軍股慄。有沙門負資而穢，酒間偶言於公，公後以他事杖殺之。其信任多此類。\n胡公既憐文長之才，哀其數困，時方省試，凡入簾者，公密屬曰：“徐子，天下才，若在本房，幸勿脫失。”皆曰：“如命。”一知縣以他羈後至，至期方謁公，偶忘屬，卷適在其房，遂不偶。\n文長既已不得志於有司，遂乃放浪曲糵，恣情山水，走齊、魯、燕、趙之地，窮覽朔漠。其所見山奔海立，沙起雲行，風鳴樹偃，幽谷大都，人物魚鳥，一切可驚可愕之狀，一一皆達之於詩。其胸中又有一段不可磨滅之氣，英雄失路、托足無門之悲，故其爲詩，如嗔如笑，如水鳴峽，如種出土，如寡婦之夜哭，羈人之寒起。當其放意，平疇千里；偶爾幽峭，鬼語秋墳。文長眼空千古，獨立一時。當時所謂達官貴人、騷士墨客，文長皆叱而奴之，恥不與交，故其名不出于越。悲夫！\n一日，飲其鄉大夫家。鄉大夫指筵上一小物求賦，陰令童僕續紙丈餘進，欲以苦之。文長援筆立成，竟滿其紙，氣韻遒逸，物無遁情，一座大驚。\n文長喜作書，筆意奔放如其詩，蒼勁中姿媚躍出。餘不能書，而謬謂文長書決當在王雅宜、文徵仲之上。不論書法，而論書神：先生者，誠八法之散聖，字林之俠客也。間以其餘，旁溢爲花草竹石，皆超逸有致。\n卒以疑殺其繼室，下獄論死。張陽和力解，乃得出。既出，倔強如初。晚年憤益深，佯狂益甚。顯者至門，皆拒不納。當道官至，求一字不可得。時攜錢至酒肆，呼下隸與飲。或自持斧擊破其頭，血流被面，頭骨皆折，揉之有聲。或槌其囊，或以利錐錐其兩耳，深入寸餘，竟不得死。\n石簣言：晚歲詩文益奇，無刻本，集藏於家。予所見者，《徐文長集》、《闕編》二種而已。然文長竟以不得志於時，抱憤而卒。\n石公曰：先生數奇不已，遂爲狂疾；狂疾不已，遂爲囹圄。古今文人，牢騷困苦，未有若先生者也。雖然，胡公間世豪傑，永陵英主，幕中禮數異等，是胡公知有先生矣；表上，人主悅，是人主知有先生矣。獨身未貴耳。先生詩文崛起，一掃近代蕪穢之習，百世而下，自有定論，胡爲不遇哉？梅客生嘗寄餘書曰：“文長吾老友，病奇於人，人奇於詩，詩奇於字，字奇於文，文奇於畫。”餘謂文長無之而不奇者也。無之而不奇，斯無之而不奇也哉！悲夫！',
  },
  {
    id: 'classic-ming-jishanshuyuanzunjinggeji',
    category: 'classic',
    dynasty: 'ming',
    title: '稽山書院尊經閣記',
    source: '王守仁',
    description: '《古文觀止》收錄之經典名篇，作者為王守仁。',
    content: '經，常道也，其在於天謂之命，其賦於人謂之性，其主於身謂之心。心也，性也，命也，一也。通人物，達四海，塞天地，亙古今，無有乎弗具，無有乎弗同，無有乎或變者也，是常道也。其應乎感也，則爲惻隱，爲羞惡，爲辭讓，爲是非；其見於事也，則爲父子之親，爲君臣之義，爲夫婦之別，爲長幼之序，爲朋友之信。是惻隱也，羞惡也，辭讓也，是非也，是親也，義也，序也，別也，信也，一也；皆所謂心也，性也，命也。通人物，達四海，塞天地，亙古今，無有乎弗具，無有乎弗同，無有乎或變者也，是常道也。是常道也，以言其陰陽消息之行焉，則謂之《易》；以言其紀綱政事之施焉，則謂之《書》；以言其歌詠性情之發焉，則謂之《詩》；以言其條理節文之著焉，則謂之《禮》；以言其欣喜和平之生焉，則謂之《樂》；以言其誠僞邪正之辯焉，則謂之《春秋》。是陰陽消息之行也以至於誠僞邪正之辯也，一也；皆所謂心也，性也，命也。通人物，達四海，塞天地，亙古今，無有乎弗具，無有乎弗同，無有乎或變者也，夫是之謂六經。六經者非他，吾心之常道也。故《易》也者，志吾心之陰陽消息者也；《書》也者，志吾心之紀綱政事者也；《詩》也者，志吾心之歌詠性情者也；《禮》也者，志吾心之條理節文者也；《樂》也者，志吾心之欣喜和平者也；《春秋》也者，志吾心之誠僞邪正者也。君子之於六經也，求之吾心之陰陽消息而時行焉，所以尊《易》也；求之吾心之紀綱政事而時施焉，所以尊《書》也；求之吾心之歌詠性情而時發焉，所以尊《詩》也；求之吾心之條理節文而時著焉。所以尊《禮》也；求之吾心之欣喜和平而時生焉，所以尊《樂》也；求之吾心之誠僞邪正而時辯焉，所以尊《春秋》也。\n蓋昔者聖人之扶人極、憂後世而述六經也，猶之富家者之父祖，慮其產業庫藏之積，其子孫者或至於遺忘散失，卒困窮而無以自全也，而記籍其家之所有以貽之，使之世守其產業庫藏之積而享用焉，以免於困窮之患。故六經者，吾心之記籍也；而六經之實，則具於吾心，猶之產業庫藏之實積，種種色色，具存於其家；其記籍者，特名狀數目而已。而世之學者，不知求六經之實於吾心，而徒考索於影響之間，牽制於文義之末，硜硜然以爲是六經矣；是猶富家之子孫，不務守視享用其產業庫藏之實積，日遺忘散失，至於窶人丐夫，而猶囂囂然指其記籍。曰：“斯吾產業庫藏之積也！”何以異於是？\n嗚呼！六經之學，其不明於世，非一朝一夕之故矣。尚功利，崇邪說，是謂亂經；習訓詁，傳記誦，沒溺於淺聞小見，以塗天下之耳目，是謂侮經；侈淫辭，競詭辯，飾奸心盜行，逐世壟斷，而猶自以爲通經，是謂賊經。若是者，是並其所謂記籍者而割裂棄毀之矣，寧復知所以爲尊經也乎？\n越城舊有稽山書院，在臥龍西崗，荒廢久矣。郡守渭南南君大吉，既敷政於民，則慨然悼末學之支離，將進之以聖賢之道，於是使山陰令吳君瀛拓書院而一新之；又爲尊經之閣於其後，曰：經正則庶民興，庶民興斯無邪慝矣。閣成，請予一言，以諗多士。予既不獲辭，則爲記之若是。嗚呼！世之學者，得吾說而求諸其心焉，其亦庶乎知所以爲尊經也矣。',
  },
  {
    id: 'classic-ming-qinzhengpian',
    category: 'classic',
    dynasty: 'ming',
    title: '親政篇',
    source: '王鏊',
    description: '《古文觀止》收錄之經典名篇，作者為王鏊。',
    content: '《易》之《泰》：“上下交而其志同。”其《否》曰：“上下不交而天下無邦。”蓋上之情達於下，下之情達於上，上下一體，所以爲“泰”。下之情壅閼而不得上聞，上下間隔，雖有國而無國矣，所以爲“否”也。\n交則泰，不交則否，自古皆然，而不交之弊，未有如近世之甚者。君臣相見，止於視朝數刻；上下之間，章奏批答相關接，刑名法度相維持而已。非獨沿襲故事，亦其地勢使然。何也？國家常朝於奉天門，未嘗一日廢，可謂勤矣。然堂陛懸絕，威儀赫奕，御史糾儀，鴻臚舉不如法，通政司引奏，上特視之，謝恩見辭，湍湍而退，上何嘗治一事，下何嘗進一言哉？此無他，地勢懸絕，所謂堂上遠於萬裏，雖欲言無由言也。\n愚以爲欲上下之交，莫若復古內朝之法。蓋周之時有三朝：庫門之外爲正朝，詢謀大臣在焉；路門之外爲治朝，日視朝在焉；路門之內爲內朝，亦曰燕朝。《玉藻》雲：“君日出而視朝，退視路寢聽政。” 蓋視朝而見羣臣，所以正上下之分；聽政而視路寢，所以通遠近之情。漢制：大司馬、左右前後將軍、侍中、散騎諸吏爲中朝，丞相以下至六百石爲外朝。唐皇城之北南三門曰承天，元正、冬至受萬國之朝貢，則御焉，蓋古之外朝也。其北曰太極門，其西曰太極殿，朔、望則坐而視朝，蓋古之正朝也。又北曰兩儀殿，常日聽朝而視事，蓋古之內朝也。宋時常朝則文德殿，五日一起居則垂拱殿，正旦、冬至、聖節稱賀則大慶殿，賜宴則紫宸殿或集英殿，試進士則崇政殿。侍從以下，五日一員上殿，謂之輪對，則必入陳時政利害。內殿引見，亦或賜坐，或免穿靴，蓋亦有三朝之遺意焉。蓋天有三垣，天子象之。正朝，象太極也；外朝，象天市也；內朝，象紫微也。自古然矣。\n國朝聖節、冬至、正旦大朝則會奉天殿，即古之正朝也。常日則奉天門，即古之外朝也。而內朝獨缺。然非缺也，華蓋、謹身、武英等殿，豈非內朝之遺制乎？洪武中如宋濂、劉基，永樂以來如楊士奇、楊榮等，日侍左右，大臣蹇義、夏元吉等，常奏對便殿。於斯時也，豈有壅隔之患哉？今內朝未復，臨御常朝之後，人臣無復進見，三殿高閟，鮮或窺焉。故上下之情，壅而不通；天下之弊，由是而積。孝宗晚年，深感有慨於斯，屢召大臣於便殿，講論天下事。方將有爲，而民之無祿，不及睹至治之美，天下至今以爲恨矣。\n惟陛下遠法聖祖，近法孝宗，盡鏟近世壅隔之弊。常朝之外，即文華、武英二殿，仿古內朝之意，大臣三日或五日一次起居，侍從、臺諫各一員上殿輪對；諸司有事諮決，上據所見決之，有難決者，與大臣面議之；不時引見羣臣，凡謝恩辭見之類，皆得上殿陳奏。虛心而問之，和顏色而道之，如此，人人得以自盡。陛下雖身居九重，而天下之事燦然畢陳於前。外朝所以正上下之分，內朝所以通遠近之情。如此，豈有近時壅隔之弊哉？唐、虞之時，明目達聰，嘉言罔伏，野無遺賢，亦不過是而已。',
  },
  {
    id: 'classic-ming-xinlingjunjiuzhaolun',
    category: 'classic',
    dynasty: 'ming',
    title: '信陵君救趙論',
    source: '唐順之',
    description: '《古文觀止》收錄之經典名篇，作者為唐順之。',
    content: '論者以竊符爲信陵君之罪，餘以爲此未足以罪信陵也。夫強秦之暴亟矣，今悉兵以臨趙，趙必亡。趙，魏之障也。趙亡，則魏且爲之後。趙、魏，又楚、燕、齊諸國之障也，趙、魏亡，則楚、燕、齊諸國爲之後。天下之勢，未有岌岌於此者也。故救趙者，亦以救魏；救一國者，亦以救六國也。竊魏之符以紓魏之患，借一國之師以分六國之災，夫奚不可者？\n然則信陵果無罪乎？曰：又不然也。餘所誅者，信陵君之心也。\n信陵一公子耳，魏固有王也。趙不請救於王，而諄諄焉請救於信陵，是趙知有信陵，不知有王也。平原君以婚姻激信陵，而信陵亦自以婚姻之故，欲急救趙，是信陵知有婚姻，不知有王也。其竊符也，非爲魏也，非爲六國也，爲趙焉耳。非爲趙也，爲一平原君耳。使禍不在趙，而在他國，則雖撤魏之障，撤六國之障，信陵亦必不救。使趙無平原，而平原亦非信陵之姻戚，雖趙亡，信陵亦必不救。則是趙王與社稷之輕重，不能當一平原公子，而魏之兵甲所恃以固其社稷者，只以供信陵君一姻戚之用。幸而戰勝，可也，不幸戰不勝，爲虜於秦，是傾魏國數百年社稷以殉姻戚，吾不知信陵何以謝魏王也。\n夫竊符之計，蓋出於侯生，而如姬成之也。侯生教公子以竊符，如姬爲公子竊符於王之臥內，是二人亦知有信陵，不知有王也。餘以爲信陵之自爲計，曷若以脣齒之勢激諫於王，不聽，則以其欲死秦師者而死於魏王之前，王必悟矣。侯生爲信陵計，曷若見魏王而說之救趙，不聽，則以其欲死信陵君者而死於魏王之前，王亦必悟矣。如姬有意於報信陵，曷若乘王之隙而日夜勸之救，不聽，則以其欲爲公子死者而死於魏王之前，王亦必悟矣。如此，則信陵君不負魏，亦不負趙；二人不負王，亦不負信陵君。何爲計不出此？信陵知有婚姻之趙，不知有王。內則幸姬，外則鄰國，賤則夷門野人，又皆知有公子，不知有王。則是魏僅有一孤王耳。\n嗚呼！自世之衰，人皆習於背公死黨之行而忘守節奉公之道，有重相而無威君，有私仇而無義憤，如秦人知有穰侯，不知有秦王，虞卿知有布衣之交，不知有趙王，蓋君若贅旒久矣。由此言之，信陵之罪，固不專系乎符之竊不竊也。其爲魏也，爲六國也，縱竊符猶可。其爲趙也，爲一親戚也，縱求符於王，而公然得之，亦罪也。\n雖然，魏王亦不得無罪也。兵符藏於臥內，信陵亦安得竊之？信陵不忌魏王，而徑請之如姬，其素窺魏王之疏也；如姬不忌魏王，而敢於竊符，其素恃魏王之寵也。木朽而蛀生之矣。古者人君持權於上，而內外莫敢不肅。則信陵安得樹私交於趙？趙安得私請救於信陵？如姬安得銜信陵之恩？信陵安得賣恩於如姬？履霜之漸，豈一朝一夕也哉！由此言之，不特衆人不知有王，王亦自爲贅旒也。\n故信陵君可以爲人臣植黨之戒，魏王可以爲人君失權之戒。《春秋》書葬原仲、翬帥師。嗟夫！聖人之爲慮深矣！',
  },
  {
    id: 'classic-ming-yilwen',
    category: 'classic',
    dynasty: 'ming',
    title: '瘞旅文',
    source: '王守仁',
    description: '《古文觀止》收錄之經典名篇，作者為王守仁。',
    content: '維正德四年秋月三日，有吏目雲自京來者，不知其名氏，攜一子一僕，將之任，過龍場，投宿土苗家。予從籬落間望見之，陰雨昏黑，欲就問訊北來事，不果。明早，遣人覘之，已行矣。\n薄午，有人自蜈蚣坡來，雲：“一老人死坡下，傍兩人哭之哀。”予曰：“此必吏目死矣。傷哉！”薄暮，復有人來，雲：“坡下死者二人，傍一人坐哭。”詢其狀，則其子又死矣。明日，復有人來，雲：“見坡下積屍三焉。”則其僕又死矣。嗚呼傷哉！\n念其暴骨無主，將二童子持畚、鍤往瘞之，二童子有難色然。予曰：“嘻！吾與爾猶彼也！”二童閔然涕下，請往。就其傍山麓爲三坎，埋之。又以只雞、飯三盂，嗟吁涕洟而告之，曰：\n嗚呼傷哉！繄何人？繄何人？吾龍場驛丞餘姚王守仁也。吾與爾皆中土之產，吾不知爾郡邑，爾烏爲乎來爲茲山之鬼乎？古者重去其鄉，遊宦不逾千里。吾以竄逐而來此，宜也。爾亦何辜乎？聞爾官吏目耳，俸不能五斗，爾率妻子躬耕可有也。烏爲乎以五斗而易爾七尺之軀？又不足，而益以爾子與僕乎？嗚呼傷哉！\n爾誠戀茲五斗而來，則宜欣然就道，胡爲乎吾昨望見爾容蹙然，蓋不任其憂者？夫衝冒霧露，扳援崖壁，行萬峯之頂，飢渴勞頓，筋骨疲憊，而又瘴癧侵其外，憂鬱攻其中，其能以無死乎？吾固知爾之必死，然不謂若是其速，又不謂爾子爾僕亦遽然奄忽也！皆爾自取，謂之何哉！吾念爾三骨之無依而來瘞爾，乃使吾有無窮之愴也。\n嗚呼傷哉！縱不爾瘞，幽崖之狐成羣，陰壑之虺如車輪，亦必能葬爾於腹，不致久暴露爾。爾既已無知，然吾何能違心乎？自吾去父母鄉國而來此，三年矣，歷瘴毒而苟能自全，以吾未嘗一日之慼慼也。今悲傷若此，是吾爲爾者重，而自爲者輕也。吾不宜復爲爾悲矣。\n吾爲爾歌，爾聽之。歌曰：連峯際天兮，飛鳥不通。遊子懷鄉兮，莫知西東。莫知西東兮，維天則同。異域殊方兮，環海之中。達觀隨寓兮，奚必予宮。魂兮魂兮，無悲以恫。\n又歌以慰之曰：與爾皆鄉土之離兮，蠻之人言語不相知兮。性命不可期，吾苟死於茲兮，率爾子僕，來從予兮。吾與爾遨以嬉兮，驂紫彪而乘文螭兮，登望故鄉而噓唏兮。吾苟獲生歸兮，爾子爾僕，尚爾隨兮，無以無侶爲悲兮！道旁之冢累累兮，多中土之流離兮，相與呼嘯而徘徊兮。餐風飲露，無爾飢兮。朝友麋鹿，暮猿與棲兮。爾安爾居兮，無爲厲於茲墟兮！',
  },
  {
    id: 'classic-ming-wurenmubeiji',
    category: 'classic',
    dynasty: 'ming',
    title: '五人墓碑記',
    source: '張溥',
    description: '《古文觀止》收錄之經典名篇，作者為張溥。',
    content: '五人者，蓋當蓼洲周公之被逮，激於義而死焉者也。至於今，郡之賢士大夫請於當道，即除魏閹廢祠之址以葬之；且立石於其墓之門，以旌其所爲。嗚呼，亦盛矣哉！\n夫五人之死，去今之墓而葬焉，其爲時止十有一月耳。夫十有一月之中，凡富貴之子，慷慨得志之徒，其疾病而死，死而湮沒不足道者，亦已衆矣；況草野之無聞者歟？獨五人之皦皦，何也？\n予猶記周公之被逮，在丙寅三月之望。吾社之行爲士先者，爲之聲義，斂貲財以送其行，哭聲震動天地。緹騎按劍而前，問：“誰爲哀者？”衆不能堪，抶而僕之。是時以大中丞撫吳者爲魏之私人毛一鷺，公之逮所由使也；吳之民方痛心焉，於是乘其厲聲以呵，則噪而相逐。中丞匿於溷藩以免。既而以吳民之亂請於朝，按誅五人，曰顏佩韋、楊念如、馬傑、沈揚、周文元，即今之傫然在墓者也。\n然五人之當刑也，意氣揚揚，呼中丞之名而詈之，談笑以死。斷頭置城上，顏色不少變。有賢士大夫發五十金，買五人之頭而函之，卒與屍合。故今之墓中全乎爲五人也。\n嗟乎！大閹之亂，縉紳而能不易其志者，四海之大，有幾人歟？而五人生於編伍之間，素不聞詩書之訓，激昂大義，蹈死不顧，亦曷故哉？且矯詔紛出，鉤黨之捕遍於天下，卒以吾郡之發憤一擊，不敢復有株治；大閹亦逡巡畏義，非常之謀難於猝發，待聖人之出而投繯道路，不可謂非五人之力也。\n由是觀之，則今之高爵顯位，一旦抵罪，或脫身以逃，不能容於遠近，而又有剪髮杜門，佯狂不知所之者，其辱人賤行，視五人之死，輕重固何如哉？是以蓼洲周公忠義暴於朝廷，贈諡褒美，顯榮於身後；而五人亦得以加其土封，列其姓名於大堤之上，凡四方之士無不有過而拜且泣者，斯固百世之遇也。不然，令五人者保其首領，以老於戶牖之下，則盡其天年，人皆得以隸使之，安能屈豪傑之流，扼腕墓道，發其志士之悲哉？故餘與同社諸君子，哀斯墓之徒有其石也，而爲之記，亦以明死生之大，匹夫之有重於社稷也。\n賢士大夫者，冏卿因之吳公，太史文起文公、孟長姚公也。',
  },
  {
    id: 'classic-ming-baoliuyizhangshu',
    category: 'classic',
    dynasty: 'ming',
    title: '報劉一丈書',
    source: '宗臣',
    description: '《古文觀止》收錄之經典名篇，作者為宗臣。',
    content: '數千裏外，得長者時賜一書，以慰長想，即亦甚幸矣；何至更辱饋遺，則不才益 將何以報焉？書中情意甚殷，即長者之不忘老父，知老父之念長者深也。\n至以「上下 相孚，才德稱位」語不才，則不才有深感焉。 夫才德不稱，固自知之矣；至於不孚之病，則尤不才爲甚。\n且今之所謂孚者，何哉？日夕策馬，候權者之門。門者故不入，則甘言媚詞，作婦人狀，袖金以私之。即門者持刺入，而主人又不即出見；立廄中僕馬之間，惡氣襲衣袖，即飢寒毒熱不可忍，不去也 。抵暮，則前所受贈金者，出報客曰：「相公倦，謝客矣！客請明日來！」即明日， 又不敢不來。夜披衣坐，聞雞鳴，即起盥櫛，走馬抵門；門者怒曰：「爲誰？」則曰 ：「昨日之客來。」則又怒曰：「何客之勤也？豈有相公此時出見客乎？」客心恥之 ，強忍而與言曰：「亡奈何矣，姑容我入！」門者又得所贈金，則起而入之；又立向 所立廄中。 幸主者出，南面召見，則驚走匍匐階下。主者曰：「進！」則再拜，故遲不起； 起則上所上壽金。主者故不受，則固請。主者故固不受，則又固請，然後命吏納之。 則又再拜，又故遲不起；起則五六揖始出。出揖門者曰：「官人幸顧我，他日來，幸 無阻我也！」門者答揖。大喜奔出，馬上遇所交識，即揚鞭語曰：「適自相公家來， 相公厚我，厚我！」且虛言狀。即所交識，亦心畏相公厚之矣。相公又稍稍語人曰：「某也賢！某也賢！」聞者亦心許交贊之。\n此世所謂上下相孚也，長者謂僕能之乎？前所謂權門者，自歲時伏臘，一刺之外，即經年不往也。閒道經其門，則亦掩耳 閉目，躍馬疾走過之，若有所追逐者，斯則僕之褊衷，以此長不見怡於長吏，僕則愈 益不顧也。每大言曰：「人生有命，吾惟有命，吾惟守分而已。」長者聞之，得無厭 其爲迂乎？\n鄉園多故，不能不動客子之愁。至於長者之抱才而困，則又令我愴然有感。天之與先生者甚厚，亡論長者不欲輕棄之，即天意亦不欲長者之輕棄之也，幸寧心哉！',
  },
  {
    id: 'classic-ming-yuranglun',
    category: 'classic',
    dynasty: 'ming',
    title: '豫讓論',
    source: '方孝孺',
    description: '《古文觀止》收錄之經典名篇，作者為方孝孺。',
    content: '士君子立身事主，既名知己，則當竭盡智謀，忠告善道，銷患於未形，保治於未然，俾身全而主安。生爲名臣，死爲上鬼，垂光百世，照耀簡策，斯爲美也。苟遇知己，不能扶危爲未亂之先，而乃捐軀殞命於既敗之後；釣名沽譽，眩世駭俗，由君子觀之，皆所不取也。\n蓋嘗因而論之：豫讓臣事智伯，及趙襄子殺智伯，讓爲之報仇。聲名烈烈，雖愚夫愚婦莫不知其爲忠臣義士也。嗚呼！讓之死固忠矣，惜乎處死之道有未忠者存焉——何也？觀其漆身吞炭，謂其友曰：“凡吾所爲者極難，將以愧天下後世之爲人臣而懷二心者也。”謂非忠可乎？及觀其斬衣三躍，襄子責以不死於中行氏，而獨死於智伯。讓應曰：“中行氏以衆人待我，我故以衆人報之；智伯以國士待我，我故以國士報之。”即此而論，讓餘徐憾矣。\n段規之事韓康，任章之事魏獻，未聞以國士待之也；而規也章也，力勸其主從智伯之請，與之地以驕其志，而速其亡也 。郄疵之事智伯，亦未嘗以國士待之也；而疵能察韓、魏之情以諫智伯。雖不用其言以至滅亡，而疵之智謀忠告，已無愧於心也。讓既自謂智伯待以國士矣，國士——濟國之上也。當伯請地無厭之日，縱慾荒暴之時，爲讓者正宜陳力就列，諄諄然而告之日：“諸侯大夫各安分地，無相侵奪，古之制也。今無故而取地於人，人不與，而吾之忿心必生；與之，則吾之驕心以起。忿必爭，爭必敗；驕必傲，傲必亡”。諄切懇至，諫不從，再諫之，再諫不從，三諫之。三諫不從，移其伏劍之死，死於是日。伯雖頑冥不靈，感其至誠，庶幾復悟。和韓、魏，釋趙圍，保全智宗，守其祭祀。若然，則讓雖死猶生也，豈不勝於斬衣而死乎？\n讓於此時，曾無一語開悟主心，視伯之危亡，猶越人視秦人之肥瘠也。袖手旁觀，坐待成敗，國士之報，曾若是乎？智伯既死，而乃不勝血氣之悻悻，甘自附於刺客之流。何足道哉，何足道哉！雖然，以國士而論，豫讓固不足以當矣；彼朝爲仇敵，暮爲君臣，腆然而自得者，又讓之罪人也。噫！',
  },
  {
    id: 'classic-ming-qingxiaxianshengwenjixu',
    category: 'classic',
    dynasty: 'ming',
    title: '青霞先生文集序',
    source: '茅坤',
    description: '《古文觀止》收錄之經典名篇，作者為茅坤。',
    content: '青霞沈君，由錦衣經歷上書詆宰執，宰執深疾之。方力構其罪，賴明天子仁聖，特薄其譴，徙之塞上。當是時，君之直諫之名滿天下。已而，君纍然攜妻子，出家塞上。會北敵數內犯，而帥府以下，束手閉壘，以恣敵之出沒，不及飛一鏃以相抗。甚且及敵之退，則割中土之戰沒者與野行者之馘以爲功。而父之哭其子，妻之哭其夫，兄之哭其弟者，往往而是，無所控籲。君既上憤疆埸之日弛，而又下痛諸將士之日菅刈我人民以蒙國家也，數嗚咽欷歔;，而以其所憂鬱發之於詩歌文章，以泄其懷，即集中所載諸什是也。\n君故以直諫爲重於時，而其所著爲詩歌文章，又多所譏刺，稍稍傳播，上下震恐。始出死力相煽構，而君之禍作矣。君既沒，而中朝之士雖不敢訟其事，而一時閫寄所相與讒君者，尋且坐罪罷去。又未幾，故宰執之仇君者亦報罷。而君之故人俞君，於是裒輯其生平所著若干卷，刻而傳之。而其子襄，來請予序之首簡。\n茅子受讀而題之曰：若君者，非古之志士之遺乎哉？孔子刪《詩》，自《小弁》之怨親，《巷伯》之刺讒而下，其間忠臣、寡婦、幽人、懟士之什，並列之爲“風”，疏之爲“雅”，不可勝數。豈皆古之中聲也哉？然孔子不遽遺之者，特憫其人，矜其志。猶曰“發乎情，止乎禮義”，“言之者無罪，聞之者足以爲戒”焉耳。予嘗按次春秋以來，屈原之《騷》疑於怨，伍胥之諫疑於脅，賈誼之《疏》疑於激，叔夜之詩疑於憤，劉蕡之對疑於亢。然推孔子刪《詩》之旨而裒次之，當亦未必無錄之者。君既沒，而海內之薦紳大夫，至今言及君，無不酸鼻而流涕。嗚呼！集中所載《鳴劍》、《籌邊》諸什，試令後之人讀之，其足以寒賊臣之膽，而躍塞垣戰士之馬，而作之愾也，固矣！他日國家採風者之使出而覽觀焉，其能遺之也乎？予謹識之。\n至於文詞之工不工，及當古作者之旨與否，非所以論君之大者也，予故不著。嘉靖癸亥孟春望日歸安茅坤拜手序。',
  },
  {
    id: 'classic-ming-yuejianglouji',
    category: 'classic',
    dynasty: 'ming',
    title: '閱江樓記',
    source: '宋濂',
    description: '《古文觀止》收錄之經典名篇，作者為宋濂。',
    content: '金陵爲帝王之州。自六朝迄於南唐，類皆偏據一方，無以應山川之王氣。逮我皇帝，定鼎於茲，始足以當之。由是聲教所暨，罔間朔南；存神穆清，與天同體。雖一豫一遊，亦可爲天下後世法。京城之西北有獅子山，自盧龍蜿蜒而來。長江如虹貫，蟠繞其下。上以其地雄勝，詔建樓於巔，與民同遊觀之樂。遂錫嘉名爲“閱江”雲。\n登覽之頃，萬象森列，千載之祕，一旦軒露。豈非天造地設，以俟大一統之君，而開千萬世之偉觀者歟？當風日清美，法駕幸臨，升其崇椒，憑闌遙矚，必悠然而動遐思。見江漢之朝宗，諸侯之述職，城池之高深，關阨之嚴固，必曰：“此朕沐風櫛雨、戰勝攻取之所致也。”中夏之廣，益思有以保之。見波濤之浩蕩，風帆之上下，番舶接跡而來庭，蠻琛聯肩而入貢，必曰：“此朕德綏威服，覃及外內之所及也。”四陲之遠，益思所以柔之。見兩岸之間、四郊之上，耕人有炙膚皸足之煩，農女有捋桑行饁之勤，必曰：“此朕拔諸水火、而登於衽席者也。”萬方之民，益思有以安之。觸類而思，不一而足。臣知斯樓之建，皇上所以發舒精神，因物興感，無不寓其致治之思，奚此閱夫長江而已哉？彼臨春、結綺，非弗華矣；齊雲、落星，非不高矣。不過樂管絃之淫響，藏燕趙之豔姬。一旋踵間而感慨系之，臣不知其爲何說也。\n雖然，長江發源岷山，委蛇七千餘裏而始入海，白湧碧翻，六朝之時，往往倚之爲天塹；今則南北一家，視爲安流，無所事乎戰爭矣。然則，果誰之力歟？逢掖之士，有登斯樓而閱斯江者，當思帝德如天，蕩蕩難名，與神禹疏鑿之功同一罔極。忠君報上之心，其有不油然而興者耶？\n臣不敏，奉旨撰記，欲上推宵旰圖治之切者，勒諸貞珉。他若留連光景之辭，皆略而不陳，懼褻也。',
  },
  {
    id: 'classic-ming-xiangciji',
    category: 'classic',
    dynasty: 'ming',
    title: '象祠記',
    source: '王守仁',
    description: '《古文觀止》收錄之經典名篇，作者為王守仁。',
    content: '靈、博之山，有象祠焉。其下諸苗夷之居者，鹹神而祠之。宣慰安君，因諸苗夷之請，新其祠屋，而請記於予。予曰：“毀之乎，其新之也？”曰：“新之。”“新之也，何居乎？”曰：“斯祠之肇也，蓋莫知其原。然吾諸蠻夷之居是者，自吾父、吾祖溯曾高而上，皆尊奉而禋祀焉，舉而不敢廢也。”予曰：“胡然乎？有鼻之祀，唐之人蓋嘗毀之。象之道，以爲子則不孝，以爲弟則傲。斥於唐，而猶存於今；壞於有鼻，而猶盛於茲土也，胡然乎？”\n我知之矣：君子之愛若人也，推及於其屋之烏，而況於聖人之弟乎哉？然則祀者爲舜，非爲象也。意象之死，其在幹羽既格之後乎？不然，古之驁桀者豈少哉？而象之祠獨延於世，吾於是蓋有以見舜德之至，入人之深，而流澤之遠且久也。\n象之不仁，蓋其始焉耳，又烏知其終之不見化於舜也？《書》不云乎：“克諧以孝，烝烝乂，不格奸。” 瞽瞍亦允若，則已化而爲慈父。象猶不弟，不可以爲諧。進治於善，則不至於惡；不抵於奸，則必入於善。信乎，象蓋已化於舜矣！《孟子》曰：“天子使吏治其國，象不得以有爲也。”斯蓋舜愛象之深而慮之詳，所以扶持輔導之者之周也。不然，周公之聖，而管、蔡不免焉。斯可以見象之既化於舜，故能任賢使能而安於其位，澤加於其民，既死而人懷之也。諸侯之卿，命於天子，蓋《周官》之制，其殆仿於舜之封象歟？\n吾於是蓋有以信人性之善，天下無不可化之人也。然則唐人之毀之也，據象之始也；今之諸夷之奉之也，承象之終也。斯義也，吾將以表於世，使知人之不善，雖若象焉，猶可以改；而君子之修德，及其至也，雖若象之不仁，而猶可以化之也。”',
  },
  {
    id: 'classic-ming-shenllun',
    category: 'classic',
    dynasty: 'ming',
    title: '深慮論',
    source: '方孝孺',
    description: '《古文觀止》收錄之經典名篇，作者為方孝孺。',
    content: '慮天下者，常圖其所難而忽其所易，備其所可畏而遺其所不疑。然而，禍常發於所忽之中，而亂常起於不足疑之事。豈其慮之未周歟？蓋慮之所能及者，人事之宜然，而出於智力之所不及者，天道也。\n當秦之世，而滅諸侯，一天下。而其心以爲周之亡在乎諸侯之強耳，變封建而爲郡縣。方以爲兵革不可複用，天子之位可以世守，而不知漢帝起隴畝之中，而卒亡秦之社稷。漢懲秦之孤立，於是大建庶孽而爲諸侯，以爲同姓之親，可以相繼而無變，而七國萌篡弒之謀。武、宣以後，稍削析之而分其勢，以爲無事矣，而王莽卒移漢祚。光武之懲哀、平，魏之懲漢，晉之懲魏，各懲其所由亡而爲之備。而其亡也，蓋出於所備之外。唐太宗聞武氏之殺其子孫，求人於疑似之際而除之，而武氏日侍其左右而不悟。宋太祖見五代方鎮之足以制其君，盡釋其兵權，使力弱而易制，而不知子孫卒困於敵國。此其人皆有出人之智、蓋世之才，其於治亂存亡之幾，思之詳而備之審矣。慮切於此而禍興於彼，終至亂亡者，何哉？蓋智可以謀人，而不可以謀天。\n良醫之子，多死於病；良巫之子，多死於鬼。豈工於活人，而拙於謀子也哉？乃工於謀人，而拙於謀天也。古之聖人，知天下後世之變，非智慮之所能周，非法術之所能制，不敢肆其私謀詭計，而唯積至誠，用大德以結乎天心，使天眷其德，若慈母之保赤子而不忍釋。故其子孫，雖有至愚不肖者足以亡國，而天卒不忍遽亡之。此慮之遠者也。夫苟不能自結於天，而欲以區區之智籠絡當世之務，而必後世之無危亡，此理之所必無者，而豈天道哉！',
  },
  {
    id: 'classic-ming-songtiantaichentingxuexu',
    category: 'classic',
    dynasty: 'ming',
    title: '送天台陳庭學序',
    source: '宋濂',
    description: '《古文觀止》收錄之經典名篇，作者為宋濂。',
    content: '西南山水，惟川蜀最奇。然去中州萬裏，陸有劍閣棧道之險，水有瞿塘、灩澦之虞。跨馬行，則篁竹間山高者，累旬日不見其巔際。臨上而俯視，絕壑萬仞，杳莫測其所窮，肝膽爲之悼慄。水行，則江石悍利，波惡渦詭，舟一失勢尺寸，輒糜碎土沉，下飽魚鱉。其難至如此。故非仕有力者，不可以遊；非材有文者，縱遊無所得；非壯強者，多老死於其地。嗜奇之士恨焉。\n天台陳君庭學，能爲詩，由中書左司掾，屢從大將北征，有勞，擢四川都指揮司照磨，由水道至成都。成都，川蜀之要地，揚子云、司馬相如、諸葛武侯之所居，英雄俊傑戰攻駐守之跡，詩人文士遊眺飲射賦詠歌呼之所，庭學無不歷覽。既覽必發爲詩，以紀其景物時世之變，於是其詩益工。越三年，以例自免歸，會予於京師；其氣愈充，其語愈壯，其志意愈高；蓋得於山水之助者侈矣。\n予甚自愧，方予少時，嘗有志於出遊天下，顧以學未成而不暇。及年壯方可出，而四方兵起，無所投足。逮今聖主興而宇內定，極海之際，合爲一家，而予齒益加耄矣。欲如庭學之遊，尚可得乎？\n然吾聞古之賢士，若顏回、原憲，皆坐守陋室，蓬蒿沒戶，而志意常充然，有若囊括於天地者。此其故何也？得無有出於山水之外者乎？庭學其試歸而求焉？苟有所得，則以告予，予將不一愧而已也！',
  },
  {
    id: 'classic-ming-linxiangruwanbiguizhaolun',
    category: 'classic',
    dynasty: 'ming',
    title: '藺相如完璧歸趙論',
    source: '王世貞',
    description: '《古文觀止》收錄之經典名篇，作者為王世貞。',
    content: '藺相如之完璧，人皆稱之。予未敢以爲信也。\n夫秦以十五城之空名，詐趙而脅其璧。是時言取璧者，情也，非欲以窺趙也。趙得其情則弗予，不得其情則予；得其情而畏之則予，得其情而弗畏之則弗予。此兩言決耳，奈之何既畏而復挑其怒也！\n且夫秦欲璧，趙弗予璧，兩無所曲直也。入璧而秦弗予城，曲在秦；秦出城而璧歸，曲在趙。欲使曲在秦，則莫如棄璧；畏棄璧，則莫如弗予。夫秦王既按圖以予城，又設九賓，齋而受璧，其勢不得不予城。璧入而城弗予，相如則前請曰：“臣固知大王之弗予城也。夫璧非趙璧乎？而十五城秦寶也。今使大王以璧故，而亡其十五城，十五城之子弟，皆厚怨大王以棄我如草芥也。大王弗與城，而紿趙璧，以一璧故，而失信於天下，臣請就死於國，以明大王之失信！”秦王未必不返璧也。今奈何使舍人懷而逃之，而歸直於秦？\n是時秦意未欲與趙絕耳。令秦王怒而僇相如於市，武安君十萬衆壓邯鄲，而責璧與信，一勝而相如族，再勝而璧終入秦矣。\n吾故曰：藺相如之獲全於璧也，天也。若其勁澠池，柔廉頗，則愈出而愈妙於用。所以能完趙者，天固曲全之哉！',
  },
  {
    id: 'classic-ming-wushantuji',
    category: 'classic',
    dynasty: 'ming',
    title: '吳山圖記',
    source: '歸有光',
    description: '《古文觀止》收錄之經典名篇，作者為歸有光。',
    content: '吳、長洲二縣，在郡治所，分境而治。而郡西諸山，皆在吳縣。其最高者，穹窿、陽山、鄧尉、西脊、銅井。而靈巖，吳之故宮在焉，尚有西子之遺蹟。若虎丘、劍池及天平、尚方、支硎，皆勝地也。而太湖汪洋三萬六千頃，七十二峯沉浸其間，則海內之奇觀矣。\n餘同年友魏君用晦爲吳縣，未及三年，以高第召入爲給事中。君之爲縣，有惠愛，百姓扳留之，不能得，而君亦不忍於其民。由是好事者繪《吳山圖》以爲贈。\n夫令之於民，誠重矣。令誠賢也，其地之山川草木，亦被其澤而有榮也；令誠不賢也，其地之山川草木，亦被其殃而有辱也。君於吳之山川，蓋增重矣。異時吾民將擇勝於巖巒之間，尸祝於浮屠、老子之宮也，固宜。而君則亦既去矣，何復惓惓於此山哉?昔蘇子瞻稱韓魏公去黃州四十餘年而思之不忘，至以爲《思黃州》詩，子瞻爲黃人刻之於石。然後知賢者於其所至，不獨使其人之不忍忘而已，亦不能自忘於其人也。\n君今去縣已三年矣。一日，與餘同在內庭，出示此圖，展玩太息，因命餘記之，噫!君之於吾吳有情如此，如之何而使吾民能忘之也!',
  },
  {
    id: 'classic-ming-simajizhulunbu',
    category: 'classic',
    dynasty: 'ming',
    title: '司馬季主論卜',
    source: '劉基',
    description: '《古文觀止》收錄之經典名篇，作者為劉基。',
    content: '東陵侯既廢，過司馬季主而卜焉。季主曰：“君侯何卜也？”東陵侯曰：“久臥者思起，久蟄者思啓，久懣者思嚏。吾聞之蓄極則泄，閟極則達。熱極則風，壅極則通。一冬一春，靡屈不伸，一起一伏，無往不復。僕竊有疑，願受教焉。”季主曰：“若是，則君侯已喻之矣，又何卜爲？”東陵侯曰：“僕未究其奧也，願先生卒教之。”季主乃言曰：“嗚呼！天道何親？惟德之親；鬼神何靈？因人而靈。夫蓍，枯草也；龜，枯骨也，物也。人，靈於物者也，何不自聽而聽於物乎？且君侯何不思昔者也？有昔者必有今日，是故碎瓦頹垣，昔日之歌樓舞館也；荒榛斷梗，昔日之瓊蕤玉樹也；露蛬風蟬，昔日之鳳笙龍笛也；鬼燐螢火，昔日之金釭華燭也；秋荼春薺，昔日之象白駝峯也；丹楓白荻，昔日之蜀錦齊紈也。昔日之所無，今日有之不爲過；昔日之所有，今日無之不爲不足。是故一晝一夜，華開者謝；一秋一春，物故者新。激湍之下，必有深潭；高丘之下，必有浚谷。君侯亦知之矣，何以卜爲？”',
  },
  {
    id: 'classic-ming-canglangtingji',
    category: 'classic',
    dynasty: 'ming',
    title: '滄浪亭記',
    source: '歸有光',
    description: '《古文觀止》收錄之經典名篇，作者為歸有光。',
    content: '浮圖文瑛居大雲庵，環水，即蘇子美滄浪亭之地也。亟求餘作《滄浪亭記》，曰：“昔子美之記，記亭之勝也。請子記吾所以爲亭者。”\n餘曰：昔吳越有國時，廣陵王鎮吳中，治南園於子城之西南；其外戚孫承祐，亦治園於其偏。迨淮海納土，此園不廢。蘇子美始建滄浪亭，最後禪者居之：此滄浪亭爲大雲庵也。有庵以來二百年，文瑛尋古遺事，復子美之構於荒殘滅沒之餘：此大雲庵爲滄浪亭也。\n夫古今之變，朝市改易。嘗登姑蘇之臺，望五湖之渺茫，羣山之蒼翠，太伯、虞仲之所建，闔閭、夫差之所爭，子胥、種、蠡之所經營，今皆無有矣。庵與亭何爲者哉？雖然，錢鏐因亂攘竊，保有吳越，國富兵強，垂及四世。諸子姻戚，乘時奢僭，宮館苑囿，極一時之盛。而子美之亭，乃爲釋子所欽重如此。可以見士之慾垂名於千載，不與其澌然而俱盡者，則有在矣。\n文瑛讀書喜詩，與吾徒遊，呼之爲滄浪僧雲。',
  },
  {
    id: 'poem-ming-zhuangyuanruilianyijingsanhua',
    category: 'poem',
    dynasty: 'ming',
    title: '狀元瑞蓮一莖三花',
    source: '陳義',
    description: '明代經典詩歌，作者為陳義。',
    content: '白蓮呈瑞水雲東，誰識天公巧用工。\n並蒂亭亭開處異，雙花灼灼本來同。\n恍疑秦晉連封國，猶訝娥英偶並宮。\n和氣兆祥當此日，羣黎鹹誦樂年豐。',
  },
  {
    id: 'poem-ming-moling',
    category: 'poem',
    dynasty: 'ming',
    title: '秣陵',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '牛首開天闕，龍岡抱帝宮。\n六朝春草裏，萬井落花中。\n訪舊烏衣少，聽歌《玉樹》空。\n如何亡國恨，盡在大江東。',
  },
  {
    id: 'poem-ming-duxianzucangzhouchushishiji',
    category: 'poem',
    dynasty: 'ming',
    title: '讀先祖滄洲處士詩集',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '八十嬰兒慕，如翁世所希。\n蘇耽今化鶴，萊子尚留衣。\n仁孝傳桑梓，文章映少微。\n無能歌祖德，手澤淚空揮。',
  },
  {
    id: 'poem-ming-qingmingzhanxianfujunmu',
    category: 'poem',
    dynasty: 'ming',
    title: '清明展先府君墓',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '蕨薇留寸草，桑梓別經年。\n積雨崩丘壟，名山失簡編。\n大招空有賦，薄祭竟無田。\n灑盡皋魚淚，蒼茫對昊天。',
  },
  {
    id: 'poem-ming-beiyouchuguifengjiacihuanjushatingzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '北遊初歸奉家慈還居沙亭作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '蘇耽成道返，阿母大歡娛。\n何意天邊月，還爲掌上珠。\n白華長抱蒂，朱鳳更將雛。\n日夕流霞獻，慈顏似鮑姑。',
  },
  {
    id: 'poem-ming-jiayuanshidimei',
    category: 'poem',
    dynasty: 'ming',
    title: '家園示弟妹',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '先人好種藥，遺我神農書。\n與子理嘗業，參苓帶雨鋤。\n道從多病入，力是耦耕餘。\n莫嘆生涯拙，韓康此隱居。',
  },
  {
    id: 'poem-ming-fengmurenlongzhoubinanyucongdizhiyinlinshiguanyoufu',
    category: 'poem',
    dynasty: 'ming',
    title: '奉母人瀧州避難寓從弟之姻林氏館有賦',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '白鵠從其母，東飛瓊樹柯。\n蘇仙頻避彈，炎女未填河。\n反哺求粱稻，孤生念蔦蘿。\n昏姻維爾故，留託泰山阿。',
  },
  {
    id: 'poem-ming-dengyuriting',
    category: 'poem',
    dynasty: 'ming',
    title: '登浴日亭',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '月明南澥闊，中夜氣鴻蒙。\n萬馬奔暘谷，雙螭御祝融。\n日輪飛上下，澥市動虛空。\n誰與同晞髮，滄涼若木東。',
  },
  {
    id: 'poem-ming-haishang',
    category: 'poem',
    dynasty: 'ming',
    title: '海上',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '海上青山好，東西聳二樵。\n三秋觀海日，半夜逐江潮。\n宮闕金銀在，仙人素手招。\n何當共徐市，一去十洲遙。',
  },
  {
    id: 'poem-ming-heshutai',
    category: 'poem',
    dynasty: 'ming',
    title: '鶴舒臺',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '英雄多羽化，高尚更安期。\n豈乏留侯舌，差爲霸者師。\n登臺駕玄鶴，涉海握神芝。\n父老菖蒲會，千秋空爾思。',
  },
  {
    id: 'poem-ming-congxuanyuanzhairumijudong',
    category: 'poem',
    dynasty: 'ming',
    title: '從軒轅宅入迷居洞',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '曉起蕊珠峯，行行花影重。\n林烏飛落月，山鬼嘯寒鍾。\n野飯芝泉冽，秋衣竹翠濃。\n昨宵逢道士，疑是七星松。',
  },
  {
    id: 'poem-ming-sujinshadong',
    category: 'poem',
    dynasty: 'ming',
    title: '宿金沙洞',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '谷口雨霏霏，樵蘇向晚稀。\n寒花秋盡發，孤鶴夜深歸。\n松定聞泉細，峯高見月微。\n幽懷如有待，竟夕倚巖扉。',
  },
  {
    id: 'poem-ming-shuzhuanwantiao',
    category: 'poem',
    dynasty: 'ming',
    title: '黍珠庵晚眺',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '松子落紛紛，樵歌隔水聞。\n秋花迷磴道，石竇出風雲。\n葛令籠䈡笛，麻姑蛺蝶裙。\n相逢歡未盡，日暮鐵橋分。',
  },
  {
    id: 'poem-ming-ziyingdezhihanguangdaozhongzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '自英德至浛洸道中作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '一縣盡奇峯，參差削玉蓉。\n人煙含亂石，瀑影出寒松。\n空翠飛猶溼，餘花落尚穠。\n亂同樵女渡，洸口暮聞鍾。',
  },
  {
    id: 'poem-ming-zhoushanglianzhou',
    category: 'poem',
    dynasty: 'ming',
    title: '舟上連州',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '路入漣江遠，愁聞是鷓鴣。\n草深迷兩岸，雲漲似重湖。\n古木撐崖墜，驚流挾石趨。\n拂舟蘿帶亂，攀折自嬉娛。',
  },
  {
    id: 'poem-ming-guoqingyuanzhutan',
    category: 'poem',
    dynasty: 'ming',
    title: '過清遠諸灘',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '沿溯頻無路，灘門雨不開。\n誰從千仞壁，飛下一舟來。\n天逐青峯轉，人隨白鳥回。\n數聲漁父笛，忽起望夫臺。',
  },
  {
    id: 'poem-ming-wangwulaofeng',
    category: 'poem',
    dynasty: 'ming',
    title: '望五老峯',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '飛翠如煙雨，秋來山色濃。\n夕陽一返照，明滅金芙蓉。\n獨嘯此亭月，將尋何處鍾。\n石門精舍近，蚤晚巢雲松。',
  },
  {
    id: 'poem-ming-zixiaofeng',
    category: 'poem',
    dynasty: 'ming',
    title: '紫霄峯',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '言攜青玉杖，千折上雲霄。\n石鏡通秋月，蘭泉應海潮。\n窗開三楚小，帆落九江遙。\n一片洪荒色，天風吹不消。',
  },
  {
    id: 'poem-ming-kaixiansilouzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '開先寺樓作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '向夕樓中臥，天風忽起西。\n不知吹瀑水，飄落幾重溪。\n窗小云爭入，林深雪已迷。\n無人愛幽獨，來共聽猿啼。',
  },
  {
    id: 'poem-ming-wangzhongshan',
    category: 'poem',
    dynasty: 'ming',
    title: '望鐘山',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '一脈茅山至，蒼蒼煙霧濃。\n神宮開六代，王氣出中峯。\n萬古君臣始，九天樓殿重。\n臥碑當輦路，春草未曾封。',
  },
  {
    id: 'poem-ming-sheshanqiuxizuo',
    category: 'poem',
    dynasty: 'ming',
    title: '攝山秋夕作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '秋林無靜樹，葉落鳥頻驚。\n一夜疑風雨，不知山月生。\n松門開積翠，潭水入空明。\n漸覺天雞曉，披衣念遠征。',
  },
  {
    id: 'poem-ming-xuanfuzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '宣府作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '往日多遊幸，雲州作帝家。\n離宮臨雁塞，御氣繞龍沙。\n青接明妃草，香傳蕭後花。\n羽林軍散後，悽切任吹笳。',
  },
  {
    id: 'poem-ming-wujin',
    category: 'poem',
    dynasty: 'ming',
    title: '烏金',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '烏金營裏市，馬乳點茶香。\n漢女燒銀鼠，蕃兒跨大羊。\n紅顏如糞土，白骨作垣牆。\n向晚吹蘆管，烏烏斷客腸。',
  },
  {
    id: 'poem-ming-yunzhouqiuwang',
    category: 'poem',
    dynasty: 'ming',
    title: '雲州秋望',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '白草黃羊外，空聞觱篥哀。\n遙尋蘇武廟，不上李陵臺。\n風助羣鷹擊，雲隨萬馬來。\n關前無數柳，一夜落龍堆。',
  },
  {
    id: 'poem-ming-chawokou',
    category: 'poem',
    dynasty: 'ming',
    title: '茶窩口',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '紫荊離十里，此處券門開。\n高壘資人去，重河拒馬來。\n冰霜秋栗烈，砧杵暮悽哀。\n漸近悲歌地，風吹易水回。',
  },
  {
    id: 'poem-ming-hanshi',
    category: 'poem',
    dynasty: 'ming',
    title: '寒食',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '蕭條寒食節，蒿里草茫茫。\n歲月添黃土，英雄聚白楊。\n報仇尋豫讓，驅馬渡清漳。\n辛苦邯鄲子，從今老戰場。',
  },
  {
    id: 'poem-ming-handandaozhong',
    category: 'poem',
    dynasty: 'ming',
    title: '邯鄲道中',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '嘆息叢臺下，英雄日寂寥。\n戰場無白日，曠野一秋雕。\n草沒廉頗宅，雲迷豫讓橋。\n悲歌誰與和，歸思晚蕭蕭。',
  },
  {
    id: 'poem-ming-xinbu',
    category: 'poem',
    dynasty: 'ming',
    title: '信部',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '歇馬風門望，襄州秋色開。\n太行盤鉅鹿，漳水繞邢臺。\n閭里聊爲俠，皇天不愛才。\n當時趙幾霸，誰繼武安來。',
  },
  {
    id: 'poem-ming-bianci',
    category: 'poem',
    dynasty: 'ming',
    title: '邊詞',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '邊郡今無事，風吹殺氣過。\n鼓鼙沉上谷，烽火斷交河。\n子女穹廬入，金珠大馬馱。\n蒙恬城下骨，夜夜聽笙歌。',
  },
  {
    id: 'poem-ming-wumenfengjingzhaoduzifuzeng',
    category: 'poem',
    dynasty: 'ming',
    title: '吳門逢京兆杜子賦贈',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '我愛秦風勁，無衣不自謀。\n美人居板屋，女子解戎輈。\n嶽走三峯勢，河吞八水流。\n君從關內至，意氣正橫秋。',
  },
  {
    id: 'poem-ming-tongduziruqinchufachuyangzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '同杜子入秦初發滁陽作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '天曉滁陽望，蒼茫大野開。\n風威肅人馬，煙色慘墩臺。\n慷慨無衣賦，艱虞不世才。\n平生一匕首，爲子入秦來。',
  },
  {
    id: 'poem-ming-zhongdu',
    category: 'poem',
    dynasty: 'ming',
    title: '中都',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '王跡興閭巷，天威奮布衣。\n三章開草昧，一戰掃金微。\n城闕中都在，人民奕世非。\n誰令原廟樹，零落向斜暉。',
  },
  {
    id: 'poem-ming-fengyang',
    category: 'poem',
    dynasty: 'ming',
    title: '鳳陽',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '神阜是鳳陽，瓜瓞接天長。\n仁祖勤耕稼，文孫肅禘嘗。\n塗山盤寢殿，淮水入宮牆。\n白首哀遺老，依依陵樹旁。',
  },
  {
    id: 'poem-ming-juci',
    category: 'poem',
    dynasty: 'ming',
    title: '具茨',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '帝受神芝籙，天開大隗宮。\n白雲迷七聖，黃蓋導雙童。\n有象成金鼎，無爲合上穹。\n龍顏如皦日，瞻望具茨東。',
  },
  {
    id: 'poem-ming-xiashidaozhong',
    category: 'poem',
    dynasty: 'ming',
    title: '硤石道中',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '天險雒陽西，臨關萬嶺低。\n冰堅人馬滑，雲暗驛樓迷。\n竦石頻當谷，飛樑忽接溪。\n幾家陶穴住，煙火暮悽悽。',
  },
  {
    id: 'poem-ming-wenxiangdaozhongchengduzi',
    category: 'poem',
    dynasty: 'ming',
    title: '閿鄉道中呈杜子',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '中條高積雪，太華遠橫雲。\n初日光相亂，芙蓉望不分。\n冰開河艇過，風起嶽鍾聞。\n明日蒼龍嶺，攀躋定與君。',
  },
  {
    id: 'poem-ming-dengtongguanhuaiyuanlou',
    category: 'poem',
    dynasty: 'ming',
    title: '登潼關懷遠樓',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '山挾洪河走，關臨隘地開。\n八州高仰屋，三輔迥當臺。\n戍晚棲烏亂，城秋班馬哀。\n茫茫王霸業，撫劍獨徘徊。',
  },
  {
    id: 'poem-ming-xiyueci',
    category: 'poem',
    dynasty: 'ming',
    title: '西嶽祠',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '地引黃河帶，天垂太華旒。\n威靈揚白帝，肅殺散高秋。\n鐘鼓存仙殿，雲霞拜岳樓。\n憑將巨靈掌，萬古蕩皇州。',
  },
  {
    id: 'poem-ming-taolinping',
    category: 'poem',
    dynasty: 'ming',
    title: '桃林坪',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '窈窕桃林峽，天如匹練垂。\n石門人獨入，谷口馬難窺。\n拂席飛泉溼，銜杯白日移。\n神仙亦塵垢，半壁玉棺遺。',
  },
  {
    id: 'poem-ming-juxiangtan',
    category: 'poem',
    dynasty: 'ming',
    title: '車箱潭',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '潭水車箱滿，潺湲春雨餘。\n上臨毛女洞，中有渭川魚。\n龍戛銅盤響，人臨水府居。\n先朝遺玉簡，靈氣發芙蕖。',
  },
  {
    id: 'poem-ming-yuntaifeng',
    category: 'poem',
    dynasty: 'ming',
    title: '雲臺峯',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '聞道黃河底，雲臺一穴通。\n水簾橫洞口，天井出空中。\n一接蒼龍脈，雙開白帝宮。\n三峯南咫尺，青翠更濛濛。',
  },
  {
    id: 'poem-ming-liqianchixiabaichixiazhuxianzhiyueding',
    category: 'poem',
    dynasty: 'ming',
    title: '歷千尺峽百尺峽諸嶮至嶽頂',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '臨崖垂半足，飛上嶽蓮端。\n玉井窺天小，蒲池弄月寒。\n白雲吞萬象，瀑水瀉千盤。\n左右石樓敞，吾將寄羽翰。',
  },
  {
    id: 'poem-ming-qingniutaifangpengjingshan',
    category: 'poem',
    dynasty: 'ming',
    title: '青牛臺訪彭荊山',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '誰鑿芙蓉翠，飛樓架此峯。\n千山圍落雁，一脈度蒼龍。\n日射黃河雪，天搖白帝鍾。\n王孫遊不返，此地種長松。',
  },
  {
    id: 'poem-ming-daxuexifengzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '大雪西峯作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '三峯蓮皎皎，萬壑雪濛濛。\n玉女花頻散，仙人霧欲空。\n光搖高掌月，聲亂紫霄風。\n天地茫茫失，驂鸞路未通。',
  },
  {
    id: 'poem-ming-taihuazuo',
    category: 'poem',
    dynasty: 'ming',
    title: '太華作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '仙掌三峯立，天門半壁扃。\n蓮花圍白帝，玉井出明星。\n橫度蒼龍磴，高歌落雁亭。\n河山襟帶盡，兩戒據天經。',
  },
  {
    id: 'poem-ming-weichuan',
    category: 'poem',
    dynasty: 'ming',
    title: '渭川',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '渭源從鳥鼠，東走向黃河。\n勢到潼關大，膏流沃野多。\n雙橋像牛女，七水匯風波。\n往日皇威震，呼韓緩轡過。',
  },
  {
    id: 'poem-ming-sanyuanrenrizuo',
    category: 'poem',
    dynasty: 'ming',
    title: '三原人日作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '春水流澌滿，雙渠接瓠中。\n橋橫清峪闊，城倚仲山雄。\n遊女驕人日，新妝儼漢宮。\n藏梅猶凍雪，著柳已光風。',
  },
  {
    id: 'poem-ming-chuzhiyanmenzengchenqigongshijun',
    category: 'poem',
    dynasty: 'ming',
    title: '初至雁門贈陳祺公使君',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '雁門雄九塞，句注壯三雲。\n開拓靈王業，驅除李牧勳。\n漢兵天上戍，羌笛月中聞。\n鎖鑰今公賴，威名回冠軍。',
  },
  {
    id: 'poem-ming-peichenshijunyouyanmenshanshui',
    category: 'poem',
    dynasty: 'ming',
    title: '陪陳使君遊雁門山水',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '斗絕開雙闕，浮雲莫與齊。\n一夫當賈屋，幹騎阻磨笄。\n白草龍沙闊，黃天雁塔低。\n使君多古意，秋爽共攀躋。',
  },
  {
    id: 'poem-ming-songtianzhangzidaifanqinjiangdenghuayue',
    category: 'poem',
    dynasty: 'ming',
    title: '送田丈自代返秦將登華嶽',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '艱難隨雨雪，邊馬急歸心。\n趙塞辭句注，秦關向華陰。\n晴開天井閣，夜聽羽人琴。\n兩戒河山首，無令壯志侵。',
  },
  {
    id: 'poem-ming-fanzhidaozhongzengzhaohoucangzhuan',
    category: 'poem',
    dynasty: 'ming',
    title: '繁峙道中贈趙侯蒼篆',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '三泉從太戲，西下作滹沱。\n白日秋來少，黃雲戰後多。\n彎弓隨大獵，扣劍和清歌。\n回首人煙裏，城樓接二峨。',
  },
  {
    id: 'poem-ming-wenyan',
    category: 'poem',
    dynasty: 'ming',
    title: '聞雁',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '雁門無數雁，一夜盡南飛。\n我憶羅浮暖，難將雨雪違。\n愁來弄羌笛，夢裏著萊衣。\n明歲梅花發，鄉園歸未歸。',
  },
  {
    id: 'poem-ming-suimusonglitianshengchuyanmen',
    category: 'poem',
    dynasty: 'ming',
    title: '歲暮送李天生出雁門',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '雄關高柳北，鴻雁出其中。\n天井開句注，長城接大同。\n青苔餘戰骨，白草失離宮。\n歲暮多風雪，愁君一轉蓬。',
  },
  {
    id: 'poem-ming-datiansheng',
    category: 'poem',
    dynasty: 'ming',
    title: '答天生',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '蒲柳先秋落，河山異代傾。\n報恩無劍術，乞食有簫聲。\n海鶴雙棲少，邊雕自獵輕。\n君憐慈母在，高義贈生平。',
  },
  {
    id: 'poem-ming-shuhun',
    category: 'poem',
    dynasty: 'ming',
    title: '述婚',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '豈意飄萍客，天涯得好仇。\n佳期牛女夕，獨立鳳凰樓。\n玉帛迎秦塞，笙歌入代州。\n威儀應敬爾，拜手荷天休。',
  },
  {
    id: 'poem-ming-chuchundaizhouzuo',
    category: 'poem',
    dynasty: 'ming',
    title: '初春代州作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '二峪冰猶壯，三關草欲薰。\n積陰開白日，春色散黃雲。\n帳小爭人合，沙平獵馬分。\n武皇諸樂府，遺響在羅裙。',
  },
  {
    id: 'poem-ming-guangchang',
    category: 'poem',
    dynasty: 'ming',
    title: '廣昌',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '此地蜚狐塞，神京一線通。\n長城帶天末，古戍接雲中。\n馬踏三秋雪，鷹吟萬里風。\n河流聲太苦，應爲客途窮。',
  },
  {
    id: 'poem-ming-futuyu',
    category: 'poem',
    dynasty: 'ming',
    title: '浮圖峪',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '石路飛狐入，天梯束馬過。\n峯頭千仞堞，峪口兩重河。\n榆柳新秋少，牛羊落日多。\n往時高殺氣，諸將此橫戈。',
  },
  {
    id: 'poem-ming-zijingguan',
    category: 'poem',
    dynasty: 'ming',
    title: '紫荊關',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '天半旗臺起，霞連落日黃。\n山開關路小，河繞塞垣長。\n蹴鞠將軍戲，酡酥上客觴。\n夜來笳鼓動，悽切助思鄉。',
  },
  {
    id: 'poem-ming-datonglci',
    category: 'poem',
    dynasty: 'ming',
    title: '大同旅次',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '獨宿天難曙，孤征日易曛。\n夢魂青冢月，涕淚白登雲。\n書斷隨陽雁，笳連守凍軍。\n代王宮咫尺，砧杵更愁聞。',
  },
  {
    id: 'poem-ming-bianye',
    category: 'poem',
    dynasty: 'ming',
    title: '邊夜',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '萬古明妃月，光含漢苑愁。\n吹來龍塞影，散作雁門秋。\n白露沾衣溼，天河接淚流。\n南飛鴻雁盡，何處寄離憂。',
  },
  {
    id: 'poem-ming-yihen',
    category: 'poem',
    dynasty: 'ming',
    title: '已恨',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '已恨關山闊，還愁鼓角悲。\n家貧難在外，年長易傷離。\n弟妹農桑苦，園林雨雪遲。\n夢中見慈母，白髮總如絲。',
  },
  {
    id: 'poem-ming-daizhouxiarifengfangbozhaoyingudasimabaigusungongyuantingjixifu',
    category: 'poem',
    dynasty: 'ming',
    title: '代州夏日馮方伯招飲故大司馬白谷孫公園亭即席賦',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '何以炎洲翠，而辭大庾梅。\n因君有瓊樹，故拂羽儀來。\n峨口朝霞起，圭峯暮雨開。\n殷勤賦公宴，持以答金罍。',
  },
  {
    id: 'poem-ming-yanmen',
    category: 'poem',
    dynasty: 'ming',
    title: '雁門',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '雁門十八隘，天欲界華夷。\n主父長城在，蒙恬古戍移。\n雄圖歸豎子，王氣走燕支。\n萬古扶蘇谷，泉聲尚恨斯。',
  },
  {
    id: 'poem-ming-zaisongtianshengxiejiazidaifanqin',
    category: 'poem',
    dynasty: 'ming',
    title: '再送天生攜家自代返秦',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '他夕高堂樂，傾觴河漢邊。\n天教兒女月，長在掌中圓。\n花萼連韋曲，田園傍渭川。\n從今衣帶緩，宴會復何年。',
  },
  {
    id: 'poem-ming-pingcheng',
    category: 'poem',
    dynasty: 'ming',
    title: '平城',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '往日平城困，閼氏畏漢威。\n三軍方彀弩，一角忽開圍。\n娘子城猶在，陳平計不非。\n只今頻月暈，誰復救龍旗。',
  },
  {
    id: 'poem-ming-jiangcongyandaifanlingnanliubiechengzhouliang',
    category: 'poem',
    dynasty: 'ming',
    title: '將從雁代返嶺南留別程周量',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '漢壘懸高柳，胡門控太行。\n三年愁出塞，萬里夢還鄉。\n馬陷渾河雪，裘沾白草霜。\n無才營菽水，蕭殺一行裝。',
  },
  {
    id: 'poem-ming-dawangruanting',
    category: 'poem',
    dynasty: 'ming',
    title: '答王阮亭',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '朝攀楓樹吟，暮拂洞庭琴。\n楚客元多怨，淮王最賞音。\n先臣有芳草，移植羅浮陰。\n採擷沾行露，憑將答所欽。',
  },
  {
    id: 'poem-ming-daxichang',
    category: 'poem',
    dynasty: 'ming',
    title: '答錫鬯',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '白日今誰照，途窮總苦辛。\n亂離難自食，高尚易違親。\n水咽扶蘇谷，花懸紫塞塵。\n悽悽知己淚，千載一沾巾。',
  },
  {
    id: 'poem-ming-mashang',
    category: 'poem',
    dynasty: 'ming',
    title: '馬上',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '馬上聽橫吹，征夫心最悲。\n邊雲多慘淡，隴水易流離。\n翠嶂盤陵邑，渾河繞嶽祠。\n時艱思用武，未忍採華芝。',
  },
  {
    id: 'poem-ming-wangtianzi',
    category: 'poem',
    dynasty: 'ming',
    title: '望田子',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '天寒宜射獵，君向大同川。\n紫兔懸鞍後，銀箏在馬前。\n沙城迷積雪，嶽樹出晴煙。\n日暮行人盡，關門待玉鞭。',
  },
  {
    id: 'poem-ming-zengchuke',
    category: 'poem',
    dynasty: 'ming',
    title: '贈楚客',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '聲詩江漢始，莫謂楚無風。\n我祖離騷賦，人稱小雅同。\n明珠貽下女，香草惠童蒙。\n之子荊南起，還將樂府工。',
  },
  {
    id: 'poem-ming-zengbieyanxiulai',
    category: 'poem',
    dynasty: 'ming',
    title: '贈別顏修來',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '斗柄垂雙華，龍門控大河。\n精靈從此得，哀樂向來過。\n白帝開珠闕，蒼龍引玉珂。\n登臨吾與汝，萬古一高歌。',
  },
  {
    id: 'poem-ming-tongchenziyouwutaizuo',
    category: 'poem',
    dynasty: 'ming',
    title: '同陳子游五臺作',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '公子追康樂，名山挾少文。\n觴浮二峨水，馬蹴五臺雲。\n北嶽連陰翠，黃沙似夕曛。\n酒酣能射虎，不必李將軍。',
  },
  {
    id: 'poem-ming-daduzi',
    category: 'poem',
    dynasty: 'ming',
    title: '答杜子',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '萬里高堂月，光從漲海來。\n衣裘軍幕冷，笳管戍樓哀。\n高舉思黃鵠，嬌歌厭落梅。\n音書頻報爾，秋別白登臺。',
  },
  {
    id: 'poem-ming-wuanjunmiao',
    category: 'poem',
    dynasty: 'ming',
    title: '武安君廟',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '往日多奇陣，飛揚教射夫。\n守真如處女，出即掃林胡。\n伏臘三關淚，兼併百戰圖。\n代州祠畔月，英爽颯虛無。',
  },
  {
    id: 'poem-ming-tangjinwangcimu',
    category: 'poem',
    dynasty: 'ming',
    title: '唐晉王祠墓',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '代北威名著，飛揚射馬鞭。\n長安回帝駕，天祐紀臣年。\n三矢山河啓，千秋俎豆懸。\n從來賜姓者，獨有晉王賢。',
  },
  {
    id: 'poem-ming-jiuri',
    category: 'poem',
    dynasty: 'ming',
    title: '九日',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '西風吹白雁，天半落秋聲。\n感此無衣客，登高賦不成。\n並門橫大漠，淶水繞長城。\n惜別那能醉，樽中酒自清。',
  },
  {
    id: 'poem-ming-jinci',
    category: 'poem',
    dynasty: 'ming',
    title: '晉祠',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '風雷纏一水，松柏貫雙溪。\n注向橫汾北，來從懸甕西。\n霸圖煙漠漠，王跡草萋萋。\n蟋蟀催遲暮，王孫思欲迷。',
  },
  {
    id: 'poem-ming-pingxing',
    category: 'poem',
    dynasty: 'ming',
    title: '平刑',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '全晉咽喉地，城橫萬疊山。\n西屏句注塞，東控紫荊關。\n砧杵三秋急，旌旗一代閒。\n天心元朔漠，臨眺且開顏。',
  },
  {
    id: 'poem-ming-wulingwangmu',
    category: 'poem',
    dynasty: 'ming',
    title: '武靈王墓',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '威靈傳主父，四戰霸山東。\n六國朱旗卻，三胡紫塞空。\n沙丘留大冢，夏屋失離宮。\n長技開中國，誰思騎射功。',
  },
  {
    id: 'poem-ming-songtianzizhiyingzhou',
    category: 'poem',
    dynasty: 'ming',
    title: '送田子之應州',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '桑渾二水合，繚繞塔兒城。\n知遠基王跡，沙陀起義兵。\n黃風吹日落，白草與天平。\n太守君知己，詩應奮夏聲。',
  },
  {
    id: 'poem-ming-daizhoufengshiyuantingfuchengzhurenyangfengshengjiu',
    category: 'poem',
    dynasty: 'ming',
    title: '代州馮氏園亭賦呈主人楊馮甥舅',
    source: '屈大均',
    description: '明代經典詩歌，作者為屈大均。',
    content: '疊嶂紛蒼翠，隨雲渡水來。\n芙蕖方伯沼，楊柳尚書檯。\n試馬分金埒，流鶯送玉杯。\n主人挾絲管，更欲畫船開。',
  },
]
